// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2715%27 height=%2715%27 viewBox=%270 0 24 24%27%3E%3Cpath d=%27M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm1 12v-6h-2v8h7v-2h-5z%27 fill=%27%23c7c7c7%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2715%27 height=%2715%27 viewBox=%270 0 24 24%27%3E%3Cpath d=%27M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm1 12v-6h-2v8h7v-2h-5z%27 fill=%27%23717171%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27 viewBox=%270 0 12 12%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    overflow-x: hidden
}

.container-fluid-hack {
    padding-left: 1px !important;
    padding-right: 1px !important;
    top: 58px;
    margin-top: 40px;
    /*position: absolute;*/
}

/*.navbar {
    line-height: normal !important;
    border-bottom: none;
    background: #fff !important;
    padding: .5rem 0rem;
    height: 80px
}*/

.navbar-brand {
    padding: 0
}

.white-content .navbar {
    border-bottom: 1px solid #9e9f9f
}
/*.navbar-brand {margin-left: 1em}*/

.navbar-brand div {
    width: 111px;
    height: 39px;
}

.navbar-nav {
    /*//margin-left: 3rem*/
}

    .navbar-nav li {
    }

.mian-nav li.nav-item {
    padding: 0.15rem 1rem;
    margin: 0 0.5rem;
}

.mian-nav li.active {
    background: #0079c2;
    border-radius: 25px
}

.mian-nav .active > .nav-link, .mian-nav .nav-link.active,
.mian-nav .nav-link.show, .mian-nav .show > .nav-link {
    color: #fff !important;
}

.navbar-dark .navbar-nav .nav-link.active {
    /* color: #495057*/
}

.navbar-dark .navbar-nav .nav-link {
    color: #333;
    /* font-family: font-m;*/
}

    .navbar-dark .navbar-nav .nav-link:focus, .navbar-dark .navbar-nav .nav-link:hover {
        /* color: #0079c2;*/
    }

/*.nav-link {
    font-size: 15px;
}*/

.nav-pills .nav-link {
    min-width: 120px;
    height: 35px;
    padding: .4rem 1rem;
    border-radius: 25px;
    border: 1px solid #ccc;
    color: black;
    font-weight: 400;
}

    .nav-pills .nav-link.active, .nav-pills .show > .nav-link {
        background-color: #02a6e5;
        border: 0
    }

.clearbr:after {
    content: ".";
    display: block;
    clear: both;
    visibility: hidden;
    line-height: 0;
    height: 0;
}

#right {   
    /* margin-left: 60%;*/
    /*bottom: 0.5rem;*/
    background: var(--grey-light);
   /* overflow-y: auto;*/
    /*border: 1px solid #ddd;
    width: 30%;*/
}



.bg-green {
    background-color: #10F041
}

.bg-blue {
    background-color: #0378C9
}

.bg-white-blue {
    background-color: #8DBFFF
}

.bg-red {
    background-color: #FF4949
}

.bg-grey {
    background-color: #DEDEDE
}

/**************************/
.drawer-handle {
    top: 15px;
    width: 31px;
    height: 30px
}

.headerCon {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    top: 0px;
}

    .headerCon .card-deck .card h5 {
        margin-bottom: 0
    }

    .headerCon .card-deck .card p {
        margin-bottom: 0
    }

.egxStats .card .card-body, .statsCon .card .card-body {
    padding: 0.1rem 0.5rem !important;
}

.mrktDetails {
    display: flex;
    flex-flow: row;
    align-items: center;
}

    .mrktDetails span, .chart_desc span.num {
        line-height: 1rem;
        margin-bottom: 0;
    }

        .mrktDetails span[data-field="last_time"] {
            background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
            background-repeat: no-repeat;
        }

        .mrktDetails span[data-field="turnover"],
        .mrktDetails span[data-field="volume"],
        .mrktDetails span[data-field="trades"] {
            font-size: 0.8125rem !important;
            color: #ffffff;
        }

.white-content .mrktDetails span[data-field="turnover"],
.white-content .mrktDetails span[data-field="volume"],
.white-content .mrktDetails span[data-field="trades"] {
    color: #1d253b;
}

.white-content .mrktDetails span[data-field="last_time"] {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
}

.mrktDetails label {
    font-weight: 300;
    margin-bottom: 0.4rem;
    /*  background: #fff;
        padding:0.3rem */
}

.mrktDetails .card-text {
    margin: 0 0.3rem
}

.card .card-text span[data-field="change"], .card .card-text span[data-field="change_percentage"] {
    font-size: smaller
}

.fixed-plugin .dropdown-menu {
    color: #fff !important;
    background: linear-gradient(#787777, #808080) !important;
}

.white-content .fixed-plugin .dropdown-menu {
    color: #9e9f9f; /*background: linear-gradient(#dee2e6, #bdc3c7);*/
    background: linear-gradient(#f1f1f1, #ffffff) !important;
}

.white-content .fixed-plugin li.header-title,
.white-content .fixed-plugin .adjustments-line .color-label {
    color: #9e9f9f;
}

.white-content .fixed-plugin .fa {
    color: #525f7f
}

.white-content .mrktDetails label, .white-content .mrktDetails .lbl {
    color: #717171;
}

.mrktDetails .card-text {
}

.mrktDetails .card-text-con {
    margin: 0 0 0 0.5rem;
    display: flex;
    text-align: center;
    line-height: 0.4rem;
}

    .mrktDetails .card-text-con label {
        display: block
    }

.statsCon {
    display: inherit;
    padding: 0.3rem
}

.dropdown-menu {
    font-size: inherit !important
}
/*layout*/
.react-grid-item:not(.react-grid-placeholder) {
    border: 1px solid black;
}


.window {
    border: 2px black solid;
    padding: 0px;
    border-radius: 4px;
    box-shadow: 3px 3px 1px gray;
    transition: box-shadow 1s;
    width: 100%;
}

.window-header {
    margin: 0px;
    height: 20px;
    background-color: #424242;
    padding: 0px 2px;
    font-size: 0.75rem !important;
    cursor: all-scroll
}

.window-title {
    color: white;
}


.window-control {
    color: #b6b6b6 !important;
    float: right;
    position: absolute;
    /* i { cursor: pointer;} */
    /* i.minus {    vertical-align: bottom;}*/
}

.white-content .window-control {
    color: #969caf !important;
}

.fl_panel_ld .ctrl_btn {
    color: #b6b6b6 !important;
}

.white-content .fl_panel_ld > div > div {
    background-color: #cccccc !important;
}

.white-content .fl_panel_ld li {
    background-color: #f5f7f7 !important;
}

    .white-content .fl_panel_ld li div div div {
        color: inherit !important;
        text-shadow: none !important;
        font-weight: bold !important;
    }

.window-content {
    width: 100%;
    top: 20px;
    position: absolute;
    bottom: 0;
    overflow-x: hidden;
    overflow-y: hidden;
    /*font-size: 0.74rem*/
}

    .window-content .input-group-append {
        width: fit-content;
    }

.window-statusbar {
    position: absolute;
    bottom: 0px;
    margin: 0px;
    width: 99.7%;
    height: 25px;
    padding: 1px;
    border-top: 1px lightgray solid;
    background: #EEEEEE;
    color: gray;
}

.window-resize-control {
    cursor: pointer;
}

.window-resize-control {
    cursor: pointer;
}

/*.closeIcon {
    position: absolute;
    top: 1px;
    cursor: pointer;
    display: block;
    font-weight: bold;
    padding: 0 0px 1px;
    width: 20px;
    text-align: center;
    border: 1px solid #5d5d5d;
    font-size:0.7rem !important
}*/

.closeIcon {
    position: absolute;
    cursor: pointer;
    top: 0px;
    font-size: 0.7rem
}

.white-content .closeIcon {
    //border: 1px solid #a8a8a8;
}

.react-grid-item.react-grid-placeholder {
    background: grey !important;
}

.window-control .wms {
    font-size: 0.7rem
}

    .window-control .wms .nav-link {
        color: #b6b6b6 !important;
        padding: 0 !important; /*.0rem 1rem*/
    }

.white-content .window-control .wms .nav-link {
    color: #969caf !important;
}

.wms .dropdown-menu {
    min-width: unset !important
}

    .wms .dropdown-menu:before {
        display: none
    }

@media screen and (max-width: 991px) {
    .wms .dropdown-toggle:after {
        display: none
    }
}

.ag-theme-balham-dark .ag-header-cell::after, .ag-theme-balham-dark .ag-header-group-cell::after {
    background-color: #5a5a5a !important
}

.ag-theme-balham, .ag-theme-balham-dark {
    font-size: inherit !important;
    font-family: inherit !important;
}


/*common*/
.agGridFullSC {
    top: 0px !important;
}

.agGridPosition {
    width: 100%;
    bottom: 0;
    top: 36px;
    position: absolute
}

.agGridPositionLev2 {
    width: 100%;
    bottom: 3.75em;
    top: 0px;
    position: absolute;
    margin-bottom: 0.2rem;
}

.bidsAsksTotals {
    position: absolute;
    bottom: 0;
    display: flex;
    flex: 1 1 50%;
    width: 95%;
    padding: 0 0.1rem
}

    .bidsAsksTotals .vals {
        width: 50%
    }

    .bidsAsksTotals label {
        font-size: inherit !important
    }

.agGridPositionTopten {
    width: 100%;
    bottom: 23px;
    top: 5px;
    position: absolute
}

.white-content .bidsAsksTotals .vals span {
    color: #333
}

.agGridPositionInves {
    width: 100%;
    bottom: 0;
    top: 0px;
    position: absolute
}

/*.quoteListOptionsContainer {
    padding-top: 3px;
    padding-bottom: 4px;
    width: 100%;
}*/

/* .quoteListOptionsContainer .input-group {
        display: inherit !important
    }*/

.quoteListOptionsContainer .input-group .btn {
    font-size: 0.75rem;
}

.searchFilterCon {
    padding-top: 3px;
    padding-bottom: 4px;
    width: 100%;
}

.quoteListMenu {
    margin: 2px 5px;
}

    .quoteListMenu select {
        width: 100%
    }


.addSymbol {
    position: absolute !important;
    z-index: 5;
    margin-top: -2px
}

/*Grid agrig Global*/


.ag-root-wrapper .ag-cell {
    overflow: hidden;
    padding-left: inherit !important;
    padding-right: inherit !important
}

.ag-row .ag-cell {
    padding-left: 2px !important;
    padding-right: 2px !important;
}

.ag-theme-balham .ag-value-change-delta, .ag-theme-balham-dark .ag-value-change-delta {
    padding-right: 0 !important
}

.ag-react-container div, .ag-react-container span {
    margin: 0 -2px;
    padding-left: 2px !important;
    padding-right: 2px !important;
}

.ag-cell-label-container {
    width: auto !important;
}

.ag-root-wrapper .ag-header-cell, .ag-root-wrapper .ag-header-group-cell {
    padding-left: 5px !important;
    padding-right: 5px !important
}

.ag-root-wrapper .ag-row-drag {
    min-width: inherit !important
}

.ag-react-container span {
    display: block;
}

.ag-header-cell {
    display: grid !important;
}

.ag-header-cell-label {
    justify-content: center !important;
}

.text-align-right {
    text-align: right
}

.text-align-center {
    text-align: center
}

/*.lm_goldenlayout {
    width: 100% !important;
    top: 49px !important;
    bottom: 0 !important;
    position: absolute !important;
}*/
/*tables*/
.ag-body-viewport {
    position: relative;
}

.ag-root ::-webkit-scrollbar, .fl_panel_ld ::-webkit-scrollbar {
    width: 5px;
    height: 5px;
}

.ag-root ::-webkit-scrollbar-track-piece, .fl_panel_ld ::-webkit-scrollbar-track-piece {
    background: #000;
    display: block
}

.white-content .ag-root ::-webkit-scrollbar-track-piece,
.white-content .fl_panel_ld ::-webkit-scrollbar-track-piece {
    background: #dee2e6;
    display: block
}

.ag-root ::-webkit-scrollbar-thumb,
.fl_panel_ld ::-webkit-scrollbar-thumb {
    background: #7a7a7a;
    display: block;
}

.white-content .ag-root ::-webkit-scrollbar-thumb,
.white-content .fl_panel_ld ::-webkit-scrollbar-thumb {
    background: #636c83 /* #7a7a7a */;
    display: block;
}

/*.ag-root ::-webkit-scrollbar {
    width: 5px;    
    height:5px;
    top:0;
    bottom:0;
    position:relative
}

.ag-root ::-webkit-scrollbar-button {
    background: #333
}

.ag-root ::-webkit-scrollbar-track-piece {
    background: #888
}

.ag-root ::-webkit-scrollbar-thumb {
    background: #eee
}

.ag-root:hover ::-webkit-scrollbar-track-piece {
    background: #000;
    display: block
}
.ag-root:hover ::-webkit-scrollbar-thumb {
    display: block;
}

*/
?
/*colors*/
.navbar {
    background-color: #1a1e34 !important
}

.white-content .navbar {
    /*background-color: #dee2e6 !important;*/
    /*background-image: linear-gradient(180deg, #dee2e6, #ffffff) !important;*/
    /*background-image: linear-gradient( 180deg, #dee2e6, #cbced9) !important;*/
    background-image: linear-gradient( 180deg, #f1f3f5, #dce0e5) !important
}

/*.quoteListOptionsContainer, .toolbar {
    font-size: 0.7rem !important
}*/

/*.quoteListOptionsContainer {
    background: #2d3436;
}

.white-content .quoteListOptionsContainer {
    background: #f5f7f7
}*/

.window-header {
    background-color: #2d3436 !important
}

.white-content .window-header { /*background-color: #f5f6fa !important;*/
    background-color: #dce0e5 !important;
    border-bottom: 1px solid #d9d9d9;
}

.react-grid-item:not(.react-grid-placeholder) {
    border: 1px solid #000 !important;
}

.white-content .react-grid-item:not(.react-grid-placeholder) {
    border: 1px solid #d4d4d4 !important;
}

.window-title {
    color: #fff;
    font-weight: bold
}

.white-content .window-title {
    color: #333;
    font-weight: bold
}

.react-tags__selected-tag {
    /*  color: inherit !important;
    background: #4a4a4a !important;
    border: 1px solid #fff;*/
}

.white-content .react-tags__selected-tag {
    color: #2d3436 !important;
    background: #F1F1F1 !important;
    border: 1px solid #D1D1D1;
}

.textselect {
    border-bottom-color: #c7c7c7 !important;
}

    .textselect:after {
        border-top: 4px solid #c7c7c7 !important;
    }

.white-content .textselect {
    border-bottom-color: #333 !important;
}

    .white-content .textselect:after {
        border-top: 4px solid #333 !important;
    }

/*Quotes*/

.ag-theme-balham .redColor, .white-content .redColor, .white-content .investorsTbl td .redColor {
    color: #de0000;
}

.ag-theme-balham .greenColor, .white-content .greenColor, .white-content .investorsTbl td .greenColor {
    color: #21a521;
}

.ag-theme-balham .blueColor, .white-content .blueColor, .white-content .investorsTbl td .blueColor {
    color: #4343ff;
}

.ag-theme-balham-dark .redColor, .redColor {
    color: #de0000;
}

.ag-theme-balham-dark .greenColor, .greenColor {
    color: #21a521; /*#10ff00*/
}

.ag-theme-balham-dark .blueColor, .blueColor {
    color: #4343ff;
}



.redColor-enter {
}

.ag-theme-balham-dark .redColor-enter-active {
    background: #ea0a0a !important;
}

.ag-theme-balham .redColor-enter-active {
    color: #fff;
    background: #de0000 !important;
}

.redColor-enter-done {
}

.redColor-exit {
}

.redColor-exit-active {
    color: inherit !important;
    background: none !important;
}

.greenColor-enter {
}

.ag-theme-balham-dark .greenColor-enter-active {
    background: #2cb323 !important;
}

.ag-theme-balham .greenColor-enter-active {
    color: #fff;
    background: #21a521 !important;
}

.greenColor-enter-done {
}

.greenColor-exit-active {
    color: inherit !important;
    background: none !important;
}

.greenColor-exit-done {
}

.noColor {
}

.noColor-enter {
}

.noColor-enter-active {
    background: inherit !important;
}

.noColor-enter-done {
}

.noColor-exit-active {
    background: inherit !important;
}

.noColor-exit-done {
    background: inherit !important;
}

.boldFont-enter {
    font-weight: bolder !important;
}

.boldFont-enter-active {
    font-weight: bolder !important;
}

.boldFont-enter-done {
    font-weight: normal !important;
}

.boldFont-exit {
    font-weight: normal;
}


/*trades*/
.ag-theme-balham .flag-a-trade {
    background-color: #d2efd2 !important;
}

.ag-theme-balham .flag-b-trade {
    background-color: #f5d6d6 !important;
}

.ag-theme-balham-dark .flag-a-trade {
    background-color: #205220 !important;
}

.ag-theme-balham-dark .flag-b-trade {
    background-color: #651818 !important;
}

/*detailed Quote*/
/*.table-responsive, .table-responsive-sm {
    background-color: #2d3436
}

.white-content .table-responsive, .white-content .table-responsive-sm {
    background-color: #fff
}
*/
.detailedQuote td, .tble td {
    padding: 2px 0 !important;
}

.tble td {
    text-align: right
}

.investorsTbl td {
    padding-right: 4px !important;
    border: 1px solid #5a5a5a;
}

.investorsTbl tr {
    color: #F5F5F5
}

.white-content .investorsTbl tr {
    color: #000
}

.white-content .investorsTbl td {
    padding-right: 4px !important;
    border: 1px solid #d9dcde;
}

/*.tble td.head {
    font-weight: bold;
    text-align: center;
    border: 1px solid #5a5a5a;
    background: #1c1c1c;
    color: rgba(245, 245, 245, 0.64)
}

.white-content .tble td.head {
    border: 1px solid #d9dcde;
    background: #f5f7f7;
    color: rgba(0, 0, 0, 0.54)
}*/

.detailedQuote .A td {
    background-color: #205220 !important;
}

.detailedQuote .B td {
    background-color: #651818 !important;
}

.white-content .detailedQuote .A td {
    background-color: #d2efd2 !important;
}

.white-content .detailedQuote .B td {
    background-color: #f5d6d6 !important;
}

.up td[data-field="CHANGE"], .up td[data-field="CHANGE_PERCENTAGE"],
.up td[data-field="LAST"], .up p, .openedStyle {
    color: #21a521 !important;
}

.down td[data-field="CHANGE"], .down td[data-field="CHANGE_PERCENTAGE"],
.down td[data-field="LAST"], .down p, .closedStyle {
    color: #de0000 !important
}

.middle td[data-field="CHANGE"], .middle td[data-field="CHANGE_PERCENTAGE"],
.middle td[data-field="LAST"], .middle p {
    color: #4343ff !important
}

.white-content .up td[data-field="CHANGE"], .white-content .up td[data-field="CHANGE_PERCENTAGE"],
.white-content .up td[data-field="LAST"], .white-content .up p, .white-content .openedStyle {
    color: #21a521 !important;
}

.white-content .down td[data-field="CHANGE"], .white-content .down td[data-field="CHANGE_PERCENTAGE"],
.white-content .down td[data-field="LAST"], .white-content .down p, .white-content .closedStyle {
    color: #de0000 !important
}

.white-content .middle td[data-field="CHANGE"], .white-content .middle td[data-field="CHANGE_PERCENTAGE"],
.white-content .middle td[data-field="LAST"], .white-content .middle p {
    color: #4343ff !important
}

/*topten*/
.agGridPositionTopten .nav-tabs .nav-link.active, .agGridPositionTopten .nav-tabs .nav-item.show .nav-link {
    font-weight: bold !important;
    color: #c3c3c3 !important;
    background-color: #2d3436 !important;
    border-color: #e3e3e3 #e3e3e3 #2f2f33 !important;
    border-bottom: none !important
}

.agGridPositionTopten .nav-tabs .nav-item {
    color: inherit
}

.white-content .agGridPositionTopten .nav-tabs .nav-item.show .nav-link,
.white-content .agGridPositionTopten .nav-tabs .nav-link.active {
    /* background-color: #f5f7f7 !important;*/
    background-color: #d2d5de !important;
    color: #333 !important;
}

.agGridPositionTopten .nav-tabs {
    background: #2d3436;
    margin-top: -4px;
}

.white-content .agGridPositionTopten .nav-tabs {
    background: #fff;
}

/*a {
    color: #00b0ff !important;
    font-weight: bold !important;
}*/

/*news*/
.news {
    background: #2d3436;
}

.white-content .news {
    background: #f5f6fa;
}

/*chart*/
.chart {
    background: #4d4e4e;
}

.white-content .chart {
    background: #d2d5de;
}

.white-content .chart {
    background: #c4c8d1;
}

.chart_desc {
    width: 150px;
}

    .chart_desc span {
        display: block;
    }

.chartbg {
    width: 128px;
    height: 20px;
    background: #e7e7e7;
    border: 1px solid #d9d8d8;
}

    .chartbg em {
        display: block;
        position: absolute;
        width: 124px;
        height: 18px;
        z-index: 10;
        text-align: center;
        color: #FFF;
        font-size: xx-small;
        padding-top: 2px;
        font-style: normal;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

        .chartbg em.advance {
            background: #2cb323;
            border: 1px solid #2cb323;
        }

        .chartbg em.declining {
            background: #d63d3d;
            border: 1px solid #ff5151;
        }

        .chartbg em.unchanged {
            background: #2c9dec;
            border: 1px solid #4343ff;
        }

.news .btn, .news select, .trades .btn, .trades select, .quoteListOptionsContainer .input-group .btn {
    font-size: 0.8rem !important;
}

.orange .drawer-handle, .orange .drawer-content-wrapper {
    background-image: linear-gradient(to bottom left, #ff8d72, #fd5d93, #ff8d72);
}

.primary .drawer-handle, .primary .drawer-content-wrapper {
    background-image: linear-gradient(to bottom left, #e14eca, #ba54f5, #e14eca);
}

.blue .drawer-handle, .blue .drawer-content-wrapper {
    background-image: linear-gradient(to bottom left, #344675, #263148, #344675);
}

.blue2 .drawer-handle, .blue2 .drawer-content-wrapper {
    background-image: linear-gradient(0deg,#3358f4,#1d8cf8)
}

.green .drawer-handle, .green .drawer-content-wrapper {
    background-image: linear-gradient( 2deg, #0098f0, #00f2c3);
}

.drawer-handle-icon, .drawer-handle-icon:before, .drawer-handle-icon:after {
    background: #fff
}

.drawer-content-wrapper a {
    color: #fff;
    font-weight: bold !important;
}

    .drawer-content-wrapper a:hover, .drawer-content-wrapper a:visited {
        color: #EEEEEE;
        text-decoration: underline
    }

/*.dropdown-menu {
    background-color: #444444 !important
}

.dropdown {
    font-size: 0.8rem
}*/

.dropdown-item {
    font-weight: 600;
    text-align: justify;
}

.sub-dropdown-item > a {
    color: #212529 !important;
    font-weight: bold;
    padding: 0.25rem 0.1rem
}
/*.white-content .dropdown-menu {
    background-color: #f5f6fa !important
}*/
/*.white-content .dropdown-item {*/
/* color: #525f7f !important;*/
/*font-weight: bold !important;
}*/
.agGridBackGround {
    background: #1c1c1c
}

.white-content .agGridBackGround {
    background: #f5f7f7
}

.connFlags {
    width: 125px;
    display: block;
    position: fixed;
    top: 12px;
}

    .connFlags div:last-child {
        margin-top: 0.2rem
    }

.circle {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-top: 0.12rem;
}

    .circle.disconnection {
        background: radial-gradient(#e21515,#9e0000 );
        border: 1px solid #ff0012;
    }

    .circle.connecting {
        background: radial-gradient(#fff42b,#a59b04 );
        border: 1px solid #f4ff00;
    }

    .circle.connected {
        background: radial-gradient(#2cb323,#14920b );
        border: 1px solid #45f939;
    }

/*.react-resizable-handle {
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' style='background-color:%23ffffff00' x='0px' y='0px' width='9px' height='9px'%3E%3Cg opacity='0.8'%3E%3Cpath d='M 6 6 L 0 6 L 0 4.2 L 4 4.2 L 4.2 4.2 L 4.2 0 L 6 0 L 6 6 L 6 6 Z' fill='%23ffffff'/%3E%3C/g%3E%3C/svg%3E") !important;
}*/

.react-grid-item > .react-resizable-handle::after {
    content: "";
    position: absolute;
    right: 3px;
    bottom: 3px;
    width: 7px !important;
    height: 7px !important;
    border-right: 2px solid #c7c7c7 !important;
    border-bottom: 2px solid #c7c7c7 !important;
}

.white-content .react-grid-item > .react-resizable-handle::after {
    content: "";
    position: absolute;
    right: 3px;
    bottom: 3px;
    width: 7px !important;
    height: 7px !important;
    border-right: 2px solid #3c75ff !important;
    border-bottom: 2px solid #2a5bd5 !important;
}

/*.white-content .react-resizable-handle {
    background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2IDYiIHN0eWxlPSJiYWNrZ3JvdW5kLWNvbG9yOiNmZmZmZmYwMCIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI2cHgiIGhlaWdodD0iNnB4Ij48ZyBvcGFjaXR5PSIwLjMwMiI+PHBhdGggZD0iTSA2IDYgTCAwIDYgTCAwIDQuMiBMIDQgNC4yIEwgNC4yIDQuMiBMIDQuMiAwIEwgNiAwIEwgNiA2IEwgNiA2IFoiIGZpbGw9IiMwMDAwMDAiLz48L2c+PC9zdmc+') !important;
}*/


.detailedQuote.table, .detailedQuote .table {
    color: #F5F5F5 !important
}

.white-content .detailedQuote.table, .white-content .detailedQuote .table {
    color: #000 !important
}

.detailedQuote .table > tbody > tr > td, .detailedQuote .table > tbody > tr > td:nth-child(odd),
.detailedQuote > tbody > tr > td:nth-child(even) {
    color: #F5F5F5
}


.detailedQuote[data-source="Quotes"] tr:nth-child(1) td {
    color: #F5F5F5
}

.white-content .detailedQuote .table > tbody > tr > td,
.white-content .detailedQuote > tbody > tr > td:nth-child(even) {
    color: #000
}

.white-content .detailedQuote .table > tbody > tr > td {
    color: #000
}

.white-content .detailedQuote[data-source="Quotes"] tr:nth-child(1) td {
    color: #000
}

.bottomPart {
    text-align: right;
    box-shadow: 0 1px 4px 0px rgb(123,123,123);
}

    .bottomPart tr td {
        padding-right: 0.2em !important;
    }

    .bottomPart table tr th {
        background-image: linear-gradient(0deg,#000000,#2f2f2f);
    }

.white-content .bottomPart table tr th {
    background-image: linear-gradient(0deg,#e8e8e8,#e2e2e2);
}

.white-content .modal .modal-header .close {
    color: #b3b3b3 !important;
}

.aboutus {
    width: 99% !important;
    padding: 0.2rem;
    direction: rtl;
    color: #fff;
    font-size: smaller;
    text-align: center
}

.sysAlert h4, .sysAlert .h4 {
    margin-bottom: 0 !important;
    line-height: inherit !important
}

.sysAlert-con {
    width: 50%;
    margin: 0 auto
}

.white-content .sysAlert-con p {
    color: rgba(255, 255, 255, 0.8) !important
}

.snDiv {
    text-align: center;
    padding: 0.2rem;
    white-space: nowrap
}

.dropdown-menu:before {
    color: #444444 !important
}

.white-content .dropdown-menu:before {
    color: #f5f6fa !important
}

::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #c7c7c7;
    opacity: 1; /* Firefox */
}

.white-content ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: #555555;
    opacity: 1; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #c7c7c7;
    opacity: 1;
}

.white-content :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: #555555;
    opacity: 1;
}

::-ms-input-placeholder { /* Microsoft Edge */
    color: #c7c7c7;
    opacity: 1;
}

.white-content ::-ms-input-placeholder { /* Microsoft Edge */
    color: #555555;
    opacity: 1;
}

.font-size-changer-buttons .btn {
    padding: 0 !important;
    margin-left: 0 !important;
}

.introjs-tooltip {
    font-size: 15px;
}

.introjs-tooltip-header {
    padding: 10px !important;
    border-bottom: 1px solid #616161 !important;
}

.white-content .introjs-tooltip-header {
    border-bottom-color: #e0e0e0 !important;
}

.introjs-tooltipbuttons {
    border-top: 1px solid #616161 !important;
}

.white-content .introjs-tooltipbuttons {
    border-top: 1px solid #e0e0e0 !important;
}

.introjs-skipbutton {
    padding: 7px 0px !important;
}

.fontSCHighlightClass {
    margin-top: 20px;
}

.introjs-tooltip {
    background-color: #2b2b2b !important;
}

.white-content .introjs-tooltip {
    background-color: #ffffff !important;
}

.introjs-button {
    border: 1px solid #616161 !important;
    text-shadow: 1px 1px 0 #323232 !important;
    color: #d0d0d0 !important;
    background-color: #484747 !important;
}

.white-content .introjs-button {
    border: 1px solid #bdbdbd !important;
    text-shadow: 1px 1px 0 #ffffff !important;
    color: #424242 !important;
    background-color: #f4f4f4 !important;
}

    .white-content .introjs-button:hover {
        border-color: #9e9e9e !important;
        background-color: #e0e0e0 !important;
        color: #212121 !important;
    }

    .white-content .introjs-button:focus {
        background-color: #eeeeee !important;
        -webkit-box-shadow: 0 0 0 0.2rem rgba(158, 158, 158, 0.5) !important;
        box-shadow: 0 0 0 0.2rem rgba(158, 158, 158, 0.5) !important;
        border: 1px solid #616161 !important;
        color: #212121 !important;
    }

    .white-content .introjs-button:active {
        background-color: #e0e0e0 !important;
        border-color: #9e9e9e !important;
        color: #212121 !important;
    }

.introjs-disabled {
    color: #4e4e4e !important;
    background-color: #2f2f2f !important;
}

    .introjs-disabled:hover, .introjs-disabled:focus {
        color: #4e4e4e !important;
        background-color: #2f2f2f !important;
    }

.white-content .introjs-disabled {
    color: #9e9e9e !important;
    background-color: #f4f4f4 !important;
}

    .white-content .introjs-disabled:hover, .white-content .introjs-disabled:focus {
        color: #9e9e9e !important;
        background-color: #f4f4f4 !important;
    }

.introjs-skipbutton {
    color: #c7c7c7 !important;
}

.white-content .introjs-skipbutton {
    color: #616161;
}

.introjs-helperLayer {
    box-shadow: rgba(33, 33, 33, 0.8) 0px 0px 1px 2px, rgba(33, 33, 33, 0.7) 0px 0px 0px 5000px !important;
    border: 1px solid !important;
}

.bidsCon > tbody > tr, .asksCon > tbody > tr {
    cursor: default
}

.bidsConDetails {
    color: rgba(255, 255, 255, 0.7) !important;
    max-height: 300px;
    overflow-y: auto
}

    .bidsConDetails th {
        text-align: center;
        padding: 5px 0 !important;
        font-size: inherit !important;
        background-image: linear-gradient(0deg,#000000,#2f2f2f);
    }

.white-content .bidsConDetails th {
    background-image: linear-gradient(0deg,#e8e8e8,#e2e2e2);
}

.bidsConDetails td {
    text-align: right;
    padding: 1px 5px 1px 1px !important
}

.white-content .bidsConDetails {
    color: rgba(255, 255, 255, 0.7) !important;
}

.alert-danger .btn-outline-danger:hover, .alert-danger .btn-outline-danger:focus, .alert-danger .btn-outline-danger:active, .alert-danger .btn-outline-danger.active, .alert-danger .btn-outline-danger:active:focus, .alert-danger .btn-outline-danger:active:hover, .alert-danger .btn-outline-danger.active:focus, .alert-danger .btn-outline-danger.active:hover,
.navbar .navbar-nav > a.alert-danger .btn-outline-danger:hover, .navbar .navbar-nav > a.alert-danger .btn-outline-danger:focus, .navbar .navbar-nav > a.alert-danger .btn-outline-danger:active,
.navbar .navbar-nav > a.alert-danger .btn-outline-danger.active, .navbar .navbar-nav > a.alert-danger .btn-outline-danger:active:focus, .navbar .navbar-nav > a.alert-danger .btn-outline-danger:active:hover,
.navbar .navbar-nav > a.alert-danger .btn-outline-danger.active:focus, .navbar .navbar-nav > a.alert-danger .btn-outline-danger.active:hover {
    background-color: #920707 !important;
    background-image: none !important;
}

.spinerLoadingDiv {
    display: flex;
    justify-content: center;
    vertical-align: middle;
    align-items: center;
    height: inherit;
    position: absolute;
    z-index: 3;
    background-color: #fff;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    margin: 0 0.9rem
}

.white-content .spinerLoadingDiv {
    background-color: #f5f7f7;
}

.connected .elementConAni, .connecting .elementConAni {
    display: none
}

.elementConAni {
    display: block;
    position: absolute;
    height: 20px;
    width: 20px;
    margin: 0 auto;
    background-color: red;
    animation-name: stretch;
    animation-duration: 0.5s;
    animation-delay: 0;
    animation-iteration-count: infinite;
    animation-fill-mode: none;
    animation-play-state: running;
    margin-top: -5px !important;
}

/*.navbar .card {
    box-shadow: 0 1px 15px 0px rgb(84, 84, 84) !important
}*/

.white-content .navbar .card {
    box-shadow: 0 1px 15px 0 rgb(244, 245, 246) !important;
}


.far:before {
    display: block
}

.add-modu button.iconbtn {
    padding: 0 !important;
    background: none !important;
    color: #9e9f9f;
    margin-right: 10px;
    font-size: 1.6em !important;
    display: block;
    border: 0;
}

.add-modu button:active, .add-modu button:focus, .add-modu button:hover {
    background-color: inherit !important;
    background-image: none !important;
    background: none !important;
    color: #bfbfbf !important
}

.white-content .add-modu button:active, .white-content .add-modu button:focus, .white-content .add-modu button:hover {
    color: #525f7f !important
}

.fixed-plugin {
    top: 19px !important;
    width: 30px !important;
}

    .fixed-plugin .fa-bars {
        font-size: 1.5em;
        color: #9e9f9f;
    }

/*.white-content .btn-primary:hover, .white-content .btn-primary:focus, .white-content .btn-primary:active, .white-content .btn-primary.active, .white-content .btn-primary:active:focus, .white-content .btn-primary:active:hover, .white-content .btn-primary.active:focus, .white-content .btn-primary.active:hover {*/
/*background-color: inherit !important;*/
/*background-image: none !important;
    border: none !important
}*/

.btn-primary:hover, .btn-primary:focus, .btn-primary:active, .btn-primary.active, .btn-primary:active:focus, .btn-primary:active:hover, .btn-primary.active:focus, .btn-primary.active:hover {
    /*background-color: inherit !important;*/
    background-image: none !important;
}

|.fixed-plugin .dropdown .dropdown-menu:after {
    border-left: 0.4em solid #787777 !important;
}

.white-content .fixed-plugin .dropdown .dropdown-menu:after {
    border-left: 0.4em solid #f1f1f1 !important;
    right: -16px;
    top: -41px
}

.fixed-plugin .dropdown .dropdown-menu:after {
    border-left: 0.4em solid #7a7a7a !important;
}

.fixed-plugin .dropdown-menu li {
    padding: 5px 2px !important;
}

.loginFrm .form-control {
    border-color: #9c9c9c !important;
}

.hg-theme-default {
    margin-top: 10px;
    color: #2d3436
}

    .hg-theme-default .hg-row:not(:last-child) {
        margin-bottom: 1px !important;
    }

    .hg-theme-default .hg-row .hg-button:not(:last-child) {
        margin-right: 1px !important;
    }

    .hg-theme-default .hg-button.hg-standardBtn {
        width: inherit !important;
    }

    .hg-theme-default .hg-button {
        border-radius: 0px !important;
        height: 30px !important;
        padding: 5px !important;
    }

    .hg-theme-default .hg-row:not(:last-child) {
        margin-bottom: 1px !important;
    }

.lm_header .lm_tab {
    padding-left: 2px !important;
    padding-right: 14px !important;
}

.agGridPositionTopten .nav-tabs .nav-link {
    border-top-left-radius: 0rem !important;
    border-top-right-radius: 0rem !important;
    padding: .2rem .2rem !important;
    border-bottom: none;
    font-weight: bold;
    margin-bottom: -2.0px;
    margin-right: 2px;
    font-family: Arial,sans-serif;
    font-size: 12px;
}

.white-content .nav-tabs .nav-link {
    border: 1px solid #cccccc;
}

.appMenu .dropdown-menu a.dropdown-item {
    padding: 0 !important;
    margin: 0 !important;
}

.appMenu .dropdown-menu a i {
    margin-right: 0;
    font-size: 0.9rem
}

.appMenu ul {
    margin-bottom: 0;
}

.wl-quotes-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    overflow-y: auto;
    height: 100%;
    min-height: 0px;
    background: #000;
    align-content: flex-start;
}

.white-content .wl-quotes-container {
    background: #f5f6fa
}

.wl-item1 {
    grid-area: h;
}

.wl-item2 {
    grid-area: ml;
    //border: 2px solid;
    padding: 0.3em;
    width: 2.9em;
    text-align: center !important
}

    .wl-item2 i {
        vertical-align: middle;
    }

.wl-item3 {
    grid-area: md;
    color: white
}

    .wl-item3 strong:first-child span:nth-child(2) {
        background: #2c354e;
        font-size: 1.2em;
        padding: 2px;
    }

.white-content .wl-item3 strong:first-child span:nth-child(2) {
    background: #eee
}

.white-content .wl-item3 {
    color: black
}

.wl-item4 {
    grid-area: f;
    text-align: center;
}

    .wl-item4 button {
        font-size: 11px;
        font-weight: normal
    }

        .wl-item4 button:hover {
            color: #fff !important
        }

        .wl-item4 button.buy-btn {
            background: none;
            border: 1px solid #007bff;
            color: #007bff;
            margin-right: 0;
        }

        .wl-item4 button.sell-btn {
            background: none;
            border: 1px solid #c758a6;
            color: #c758a6;
            margin-left: 0;
        }

.white-content .wl-item4 button.buy-btn {
    border: 1px solid #0000ff;
    color: #0000ff;
}

.white-content .wl-item4 button.sell-btn {
    border: 1px solid #b5007f;
    color: #b5007f;
}


.wl-quote strong {
    white-space: nowrap
}

.wl-quote.up strong.numbs, .wl-quote.up .wl-item2 .fas {
    color: #21a521
}

.wl-quote.down strong.numbs, .wl-quote.down .wl-item2 .fas {
    color: #de0000;
}

.wl-quote.middle strong.numbs, .wl-quote.middle .wl-item2 .fas {
    color: #4343ff;
}

.wl-quote.up, .wl-quote.up .wl-item2 {
    border-color: #21a521
}

.wl-quote.down, .wl-quote.down .wl-item2 {
    border-color: #de0000
}

.wl-quote.middle, .wl-quote.middle .wl-item2 {
    border-color: #4343ff
}
/*************/
.white-content .wl-quote.up strong.numbs, .white-content .wl-quote.up .wl-item2 .fas {
    color: #21a521
}

.white-content .wl-quote.down strong.numbs, .white-content .wl-quote.down .wl-item2 .fas {
    color: #de0000;
}

.white-content .wl-quote.middle strong.numbs, .white-content .wl-quote.middle .wl-item2 .fas {
    color: #4343ff;
}

.white-content .wl-quote.up, .white-content .wl-quote.up .wl-item2 {
    border-color: #21a521
}

.white-content .wl-quote.down, .white-content .wl-quote.down .wl-item2 {
    border-color: #de0000
}

.white-content .wl-quote.middle, .white-content .wl-quote.middle .wl-item2 {
    border-color: #4343ff
}

.c-time-con {
    width: 100%;
    height: inherit;
    padding-top: 1rem;
}

.c-time {
    text-align: center;
    font-size: larger;
    font-weight: bold;
    margin: 0.5rem 0
}

    .c-time strong {
        color: #fff
    }

.white-content .c-time strong {
    color: #000
}

.react-countdown-clock {
    margin: 0 auto
}

.white-content .indx-con {
    background: #fff;
}

.indx-con hr {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
}

.indx-con .indx-val {
    font-size: 1.2em;
    font-weight: 600
}

.indx-row {
    padding-top: 0.7em;
}

.indx-wrapper {
    display: grid;
    /*grid-gap: 10px;*/
    grid-template-columns: 30px 150px;
    align-items: center;
}

.indx-a {
    grid-column: 1 / 2;
    grid-row: 1 / 3;
}

.indx-b {
    grid-column: 2;
    grid-row: 1 / 2;
}

.indx-c {
    grid-column: 2;
    grid-row: 2;
}

.indx-flex .flex-items {
    display: flex;
    flex-wrap: nowrap;
}

.flex-items > div {
    width: 80px;
    /*margin: 5px;
    padding:2px;
    text-align: center;
    line-height: 75px;*/
}

.canvasjs-chart-credit {
    display: none
}

.input-group-append .sepBorder {
    height: 20px
}

.PanelArea {
    display: flex;
    flex-direction: column;
}

.PanelContentArea {
    height: 100%;
    width: 100%;
    background-color: var(--color-panel-background);
    /* display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;*/
    overflow: auto !important;
    overflow-x: hidden !important;
    border-radius: 0.5rem;
    padding: 0.5em
}

.ResizeHandleOuter {
    flex: 0 0 2em;
    position: relative;
    outline: none;
    background-color: #363636 /* #7a7a7a4a*/ /*  --background-color: transparent; */
}

    .ResizeHandleOuter[data-resize-handle-active] {
        --background-color: var(--color-solid-resize-bar-handle);
    }

.white-content .ResizeHandleOuter {
    background-color: #d2d6dd !important
}

.ResizeHandleInner {
    position: absolute;
    top: 0.25em;
    bottom: 0.25em;
    left: 0.25em;
    right: 0.25em;
    border-radius: 0.25em;
    background-color: #2e2e2e; /* #ffffff var(--background-color) */
    transition: background-color 0.2s linear;
}

.white-content .ResizeHandleInner {
    background-color: #636c83 !important
}

.Button {
    color: var(--color-default);
    background-color: var(--color-button-background);
    border: 1px solid var(--color-button-border);
    border-radius: 0.25rem;
    padding: 0.25rem 0.5rem;
    cursor: pointer;
}

    .Button:hover {
        background-color: var(--color-button-background-hover);
    }

.Link {
    display: block;
    color: var(--color-link);
    margin-bottom: 0.5rem;
}

.Icon {
    width: 1em;
    height: 1em;
    position: absolute;
    left: calc(50% - 0.5rem);
    top: calc(50% - 0.35rem);
    color: #fff;
}

.accTypeDd .dropdown-item.active {
    color: #fff !important;
    text-decoration: none !important;
    background-color: #007bff !important;
}

.white-content .accTypeDd .dropdown-item.active {
    color: #fff !important;
    text-decoration: none !important;
    background-color: #007bff !important;
}

.balance-area .rendered-text-span, .move-money-form .rendered-text-span {
    font-weight: bold
}

hr {
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
}

.first-row {
    background: #f1f1f1;
    padding: 0.5rem 0;
    margin: 0 0 1rem 0;
}

.position-panel .first-row > div > * {
    margin-bottom: 0 !important;
}

#dropdownAccType {
    width: 120px
}

.order-ticket .input-group, .order-ticket .form-group {
    margin-bottom: 0 !important;
}

.order-ticket .form-check {
    margin-top: 0 !important;
}

.order-ticket label {
    font-size: 13px
}

.order-ticket .form-group .form-control, .order-ticket .input-group .form-control {
    padding: inherit !important
}

.order-ticket .form-check .form-check-label, .order-ticket .custom-control-label {
    width: 100%;
}

.form-control:focus {
    border-color: #808080 !important;
}

.white-content .form-control:focus {
    border-color: #424242 !important;
}

.order-ticket .custom-radio .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #007bff !important;
    border-color: #007bff !important;
}

.order-ticket .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #007bff;
}

.white-content .order-ticket .quoteListOptionsContainer,
.white-content .create-alert .quoteListOptionsContainer {
    background: none;
}

.order-ticket .quoteListOptionsContainer,
.create-alert .quoteListOptionsContainer {
    padding: 0 !important;
    background: none;
}

    .order-ticket .quoteListOptionsContainer .input-group,
    .create-alert .quoteListOptionsContainer .input-group {
        display: flex !important;
        flex-wrap: nowrap;
    }


.white-content .order-ticket .react-tags__search input,
.white-content .create-alert .react-tags__search input {
    background: #fff !important;
    color: #222a42 !important;
    border: 1px solid #ced4da;
}

.white-content .order-ticket .react-tags,
.white-content .create-alert .react-tags {
    background: none !important;
    border-color: #1d253b80
}



.order-ticket .react-tags input,
.create-alert .react-tags input {
    background: none !important;
    border-top-left-radius: 0.4rem;
    border-bottom-left-radius: 0.4rem;
    background-color: transparent;
    background-clip: padding-box;
    /* border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
    */
}




.white-content .order-ticket .form-control {
    background: #fff;
    /* border: 1px solid #898e9b*/
}

.order-ticket .form-control {
    /* border-color: #666666;*/
    background: #000;
}

.order-quote-brief {
    box-shadow: 0 1px 8px 0px rgb(123 123 123 / 60%) !important;
    border-radius: 20px;
    border: 1px solid #bcbdc2;
}

    .order-quote-brief .table-responsive-sm, .order-quote-brief .table-responsive {
        padding-bottom: 0 !important
    }

    .order-quote-brief:nth-child(1) > .table-responsive-sm {
        padding: 0.3rem
    }

    .order-quote-brief .wl-quote {
        width: auto;
        max-width: 100%;
        margin: 0px;
        padding: 0em;
        background: none
    }

    .order-quote-brief .wl-item1 {
        height: auto
    }

    .order-quote-brief .bottomPart td:nth-child(2) div {
        border: none !important
    }

    .order-quote-brief tr:nth-child(1) td.first-td {
        border: none;
        padding: 0px !important
    }

    .order-quote-brief .bottomPart {
        box-shadow: none;
    }

    .order-quote-brief .bidsCon th, .order-quote-brief .asksCon th {
        text-align: center
    }

.white-content select.form-control option,
.move-money-form select.form-control option {
    padding: 0.3rem 0;
    font-size: 13px;
    color: #333
}

select.form-control option {
    padding: 0.3rem 0;
    font-size: 13px;
    color: #333
}

.btn-buy {
    background: blue !important;
    color: #fff !important;
}

.btn-sell {
    background: #c51f1f !important;
    color: #fff !important;
}

.order-ticket .btn-buy:hover, .order-ticket .btn-buy:focus, .order-ticket .btn-buy:active,
.order-ticket .btn-buy.active, .order-ticket .btn-buy:active:focus, .order-ticket .btn-buy:active:hover,
.order-ticket .btn-buy.active:focus, .order-ticket .btn-buy.active:hover {
    background-color: blue !important;
    background-image: none !important;
}

.order-ticket .btn-sell:hover, .order-ticket .btn-sell:focus, .order-ticket .btn-sell:active,
.order-ticket .btn-sell.active, .order-ticket .btn-sell:active:focus, .order-ticket .btn-sell:active:hover,
.order-ticket .btn-sell.active:focus, .order-ticket .btn-sell.active:hover {
    background-color: #c51f1f !important;
    background-image: none !important;
}

.was-validated .custom-control-input:valid ~ .custom-control-label::before {
    background-color: inherit !important;
    border-color: inherit !important;
    /*border: inherit !important;*/
}

.was-validated .custom-control-input:valid ~ .custom-control-label,
.custom-control-input.is-valid ~ .custom-control-label {
    color: inherit !important
}

.was-validated .form-control:valid {
    border-color: #28a745 !important;
    background-image: none !important;
}

.was-validated .reuter-error {
    display: block
}

.was-validated .reuter-col-error .quoteListOptionsContainer {
    border-color: #ff8d72;
    padding-right: calc(1.5em + 0.75rem);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-repeat: no-repeat;
    background-position: right calc(0.375em + 0.1875rem) center;
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.was-validated .reuter-col-error .react-tags__search input {
    border: 1px solid #ff8d72 !important
}



.trading-alert-con .h4 {
    margin-bottom: 0;
}

.trading-alert-con p {
    color: #1d253b;
    font-weight: bold
}

.modal-content .modal-body {
    /*line-height: 1.9 !important;*/
    padding: 10px 24px 10px 24px;
}

.move-money-form {
    /*margin-top:0.5rem*/
}

    .custome-card h5, .custome-card .h5, .move-money-form h5 {
        margin-bottom: 0.5rem !important
    }



.display-flex {
    display: flex
}

.btn-cancel {
    opacity: 0.6;
    background: #858585 !important;
    background-image: none !important
}

    .btn-cancel:hover, .btn-cancel:focus, .btn-cancel:active, .btn-cancel.active, .btn-cancel:active:focus,
    .btn-cancel:active:hover, .btn-cancel.active:focus, .btn-cancel.active:hover {
        opacity: 1;
        background-color: #5a5a5a !important;
        background-image: none !important
    }



.sector-rank .badge {
    font-size: 100%
}

.sector-rank .h5 {
    margin-top: 0.5rem
}

.sector-rank .nav-tabs .nav-item.show .nav-link, .sector-rank .nav-tabs .nav-link.active {
    color: #495057 !important;
    background-color: #fff !important;
    border-color: #dee2e6 #dee2e6 #fff !important;
}

.sector-rank .nav-link {
    padding: 0.5rem 0.7rem
}

.user-profile .form-check {
    margin-top: 0 !important
}

.formStyleError {
    border-color: red,
}

.formErrorMsg {
    color: red;
    font-size: x-small;
    align-self: flex-start;
    /*padding-top: 2px*/
}

.user-profile input {
    margin-bottom: 0.1rem
}

.user-profile .form-group {
    margin-bottom: 0.1rem;
}

.fixed-plugin .appMenu .dropdown-menu {
    width: auto;
}

.font-icon {
    font-size: 0.9em !important
}

.column-gap-1 {
    column-gap: 0.1rem
}

.column-gap-2 {
    column-gap: 0.2rem
}

.column-gap-3 {
    column-gap: 0.3rem
}

.column-gap-4 {
    column-gap: 0.4rem
}

.column-gap-5 {
    column-gap: 0.5rem
}

.translate-middle {
    transform: translate(-50%,-10%) !important;
    z-index: 10;
}

.start-100 {
    left: 100% !important;
}

.start-75 {
    left: 75% !important;
}

.top-0 {
    top: 0 !important;
}



.dropdown-toggle::after {
    display: none;
}

.ag-theme-balham .ag-root-wrapper {
    border: 0px !important
}

@media (min-width: 576px) {
    .small-modal .modal-dialog {
        max-width: 30vw !important;
    }

    .medium-modal .modal-dialog {
        max-width: 55vw !important;
    }

    .large-modal .modal-dialog {
        max-width: 75vw !important;
    }
}

.fixed-plugin .fa {
    color: #ffffff;
    padding: 10px;
    border-radius: 0 0 6px 6px;
    width: auto;
}

.user-alerts, .user-alerts .tab-content {
    width: 100%
}

.fa-medium-font {
    font-size: 1.5em
}

.alert-conf-row {
    padding: 1rem;
    justify-content: end;
    gap: 2rem;
    background: #f3f3f3;
    margin-right: 1rem !important;
    margin-left: 1rem !important;
    border: 1px solid #ffffff;
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
    border-top: 0;
    box-shadow: 0px 1px 3px lightgrey inset
}



.detailed-quote .wl-quote {
    width: 75%;
    max-width: 90%
}

.sell-color-btn-outline {
    border: 1px solid #d63d3d;
    color: #d63d3d;
}

.buy-color-btn-outline {
    border: 1px solid #0000ff;
    color: #0000ff;
}

.sell-color-btn {
    border: 1px solid #d63d3d !important;
    background-color: #d63d3d !important;
}

.buy-color-btn {
    border: 1px solid #0000ff !important;
    background-color: #0000ff !important;
}

.opacity-contrast {
    opacity: 0.8
}

.detailed-quote .btn {
    padding: 3px 30px !important
}

.cursor-pointer {
    cursor: pointer
}

.detailed-quote .table-responsive {
    padding-bottom: 0
}

.detailed-quote hr {
    margin-top: 0 !important
}

.detailed-quote .toast {
    font-size: inherit
}

.modal-search-backdrop {
    opacity: 0.2
}

.modal-search .quoteListOptionsContainer {
    background: #fff;
}

.modal-search .react-tags__search input {
    background: #fff;
    width: 100% !important
}

.modal-search .react-tags {
    background: #fff;
    width: 100% !important
}

.modal-search .input-group-append {
    display: none
}

.detailed-quote .list-group-horizontal > button {
    min-width: 110px
}

/*.table td, .table th {
    padding: 0.1em
}*/

.detailed-quote table .A td {
    color: #21a521 !important;
    /*  background-color: #c3e6cb !important;
    border: 1px solid #15572406*/
}

.detailed-quote table .B td {
    color: #de0000 !important;
    /* background-color: #f5c6cb !important;
    border: 1px solid #721c2406;*/
}

.fa-sm {
    font-size: 0.5em !important
}

.max-scroll-clip {
    height: 315px
}


/*@media (min-width: 1200px) {
    .col-xl-3 {       
        flex: 0 0 33.333333%;
        max-width: 33.333333%;
    }
}*/
@keyframes stretch {
    0% {
        transform: scale(0.3);
        background-color: red;
        border-radius: 100%;
    }

    50% {
        opacity: 0.5
    }

    100% {
        transform: scale(1.5);
        background-color: red;
        border-radius: 100%;
        opacity: 0.1
    }
}
/* all row drag */
/*.ag-cell[col-id="reuters"] {
    overflow: inherit !important;
}

    .ag-cell[col-id="reuters"] .ag-cell-value {
        padding-left: 0px;
    }

    .ag-cell[col-id="reuters"] .ag-icon {
        visibility:hidden
    }

    .ag-cell[col-id="reuters"] .ag-row-drag {
        position: absolute;
        width: 1200px;
        z-index: 2;
    }
*/


@media screen and (min-width: 30em) {
    .react-tags__search {
        /* this will become the offsetParent for suggestions */
        position: relative;
    }
}

@media only screen and (max-width: 500px) {
    .mrktDetails {
        display: none
    }
}

@media only screen and (max-width: 630px) {

   

    .egxStats .card:nth-child(1) {
        display: none
    }

    #popover-contained {
        width: 275px;
    }

        #popover-contained .col:last-child {
            display: none
        }

    .pp-table table th {
        font-size: 8px;
    }

    .pp-table table td {
        font-size: 9px !important;
    }
        
}

#popover-alerts {
}

@media only screen and (max-width: 735px) {
    .egxStats .card:nth-child(2) {
        display: none
    }

    .navbar {
        line-height: normal !important;
        /*border-bottom: 1px solid;*/
        background-color: #fff !important;
        padding: .5rem 0rem !important;
        height: auto !important;
    }

    .navbar-collapse {
        border-bottom: 1px solid #ccc !important;
        padding-bottom:1rem
    }

    .navbar-nav {
        margin-left: 0 !important;
        margin-top: 1rem !important;
        margin-bottom: 1rem !important;
    }

    .mian-nav li.nav-item {
        margin: 0 !important;        
    }

    .nav-pills .nav-link {
        min-width: 100px !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        margin:0.4rem 0.2rem
    }
}

@media only screen and (max-width: 810px) {
    .egxStats .card:nth-child(3) {
        display: none
    }

    .sysAlert-con {
        width: 100%;
    }
}

@media only screen and (max-width: 770px) {

    #left {
        float: none !important;
        width: 100% !important;
    }

    #right {
        float: none !important;
        width: 100% !important;
    }
}


@media only screen and (max-width: 880px) {
    .egxStats .card:nth-child(4) {
        display: none
    }

    #right {
        /*display: none*/
        /* top: 140px;*/
        position: inherit;
        /*clear: both;*/
    }

    #left {
        width: 100% !important;   
    }

    .welcome-div {
        display: none
    }

    /*.navbar {
        line-height: normal !important;
        border-bottom: none;
        background-color: #fff !important;
        padding: .5rem 0rem;
        height: 80px;
    }*/

    .pp-table table th {
        font-size: 10px;
    }

    .pp-table table td {
        font-size: 11px;
    }
}


@media only screen and (min-width: 820px) {
    .egxStats .card:nth-child(4) {
        display: none
    }

    .navbar {
        line-height: normal !important;
        border-bottom: none;
        background-color: #fff !important;
        padding: .5rem 0rem;
        height: 80px;
    }

    .navbar-collapse {
        border-bottom: none !important;
    }

    #right {
        width: 38%
    }

    #left {
        width: 60% !important;
        /*float: none*/
    }

    .welcome-div {
        display: none
    }

    .pp-table table th {
        font-size: 11px;
    }

    .pp-table table td {
        font-size: 12px;
    }
}

@media only screen and (min-width: 990px) {
    .egxStats .card:nth-child(4) {
        display: none
    }
  
    .navbar {
        line-height: normal !important;
        border-bottom: none;
        background-color: #fff !important;
        padding: .5rem 0rem;
        height: 80px;
    }

    .navbar-collapse {
        border-bottom: none !important;
    }   

    #right {       
        width: 28%
    }    

    #left {
        width: 70% !important;
        /*float: none*/
    }

    .welcome-div {
        display:none
    }

    .pp-table table th {
        font-size: 11px;
    }

    .pp-table table td {
        font-size: 12px;
    }
}

@media (min-width: 1200px) {
    #right {
        top: 144px;
        width: 350px;
        position: absolute; /*fixed*/
        min-height: 83.5vh;
        transition: top 0.1s ease-out; /* This creates the smooth movement effect */
    }

    #left {
        width: 840px !important;
        /*padding-right: 10px;*/
        /*border: 1px solid #de0000*/
    }
   

    #portfolio-card button {
        font-size: 12px !important;
        font-weight: 600 !important;
    }
    .welcome-div {
        display: block
    }

    .col-xl-8 {
        width: 60.5% !important;
    }

    .pp-table table th {
        font-size: 12px;
    }

    .pp-table table td {
        font-size: 13px;
    }
}

@media only screen and (max-width: 1240px) {
    .statsCon {
        display: none
    }

    
    
}

@media only screen and (min-width: 1280px) {    

    #root .container-fluid {
        max-width: 1280px;
        width: 1280px;
        padding: 0 40px;
        /*border: 1px solid #000;*/
    }

    #left {
        width: 810px !important;
        /*padding-right: 10px;*/
        /*border: 1px solid #de0000*/
    }

    #right {
        width: 350px;
        max-width: 350px;
        padding: 10px;
        font-size: 12px
        /*border: 1px solid #21a521*/
    }

    .col-xl-8 {
        width: 60.5% !important;
    }
    
}

@media only screen and (min-width: 1366px) {    

    #root .container-fluid {
        max-width: 1360px;
        width: 1360px;
        padding: 0 20px;
        /*border: 1px solid #000;*/
    }

    #left {
        width: 955px !important;
        /*padding-right: 10px;*/
        /*border: 1px solid #de0000*/
    }

    #right {
        width: 350px;
        max-width: 350px;
        padding: 10px;
        font-size: 12px
        /*border: 1px solid #21a521*/
    }  

    #portfolio-card button {
        font-size: 13px !important;
        font-weight: inherit !important;
    }

    .pp-table table td {
        font-size: 14px;
    }
}


@media only screen and (min-width: 1440px) {
    #root .container-fluid {
        width: 1512px;
        max-width: 1512px;
        padding: 0 45px;
        /*border: 1px solid #000;*/
    }

    #left {
        /*width: 1027px !important;*/
        width: 1010px !important;
        /*padding-right: 20px;*/
        /*border: 1px solid #de0000*/
    }

    #right {
        /*width: calc(1440px - 960px) !important;*/
        width: 373px;
        max-width: 413px;
        padding: 20px;
        font-size: inherit !important;
        /*border: 1px solid #21a521*/
    }

    .col-xl-8 {
        width: 67.666667% !important;
    }

    .pp-table table td {
        font-size: 15px;
    }
}
`, "",{"version":3,"sources":["webpack://./client/assets/style/skeleton.css"],"names":[],"mappings":"AAAA;IACI;AACJ;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,SAAS;IACT,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;;;;;;EAME;;AAEF;IACI;AACJ;;AAEA;IACI;AACJ;AACA,mCAAmC;;AAEnC;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;IAEI;IACA;;AAEJ;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB;AACJ;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,wBAAwB;AAC5B;;IAEI;QACI,mBAAmB;IACvB;;AAEJ;;EAEE;;AAEF;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;AACpB;;IAEI;QACI,yBAAyB;QACzB;IACJ;;AAEJ;IACI,YAAY;IACZ,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,6BAA6B;GAC9B,qBAAqB;IACpB;gBACY;AAChB;;;;AAIA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA,2BAA2B;AAC3B;IACI,SAAS;IACT,WAAW;IACX;AACJ;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;;IAEI;QACI;IACJ;;IAEA;QACI;IACJ;;AAEJ;IACI,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;AACvB;;IAEI;QACI,iBAAiB;QACjB,gBAAgB;IACpB;;QAEI;YACI,yDAAqW;YACrW,4BAA4B;QAChC;;QAEA;;;YAGI,+BAA+B;YAC/B,cAAc;QAClB;;AAER;;;IAGI,cAAc;AAClB;;AAEA;IACI,yDAAqW;IACrW,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB;wBACoB;AACxB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,sBAAsB;IACtB,wDAAwD;AAC5D;;AAEA;IACI,cAAc,EAAE,iDAAiD;IACjE,wDAAwD;AAC5D;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;AACA;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;;IAEI;QACI;IACJ;;AAEJ;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;AACA,SAAS;AACT;IACI,uBAAuB;AAC3B;;;AAGA;IACI,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,4BAA4B;IAC5B,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,gBAAgB;IAChB,6BAA6B;IAC7B;AACJ;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;IAEI;QACI,yBAAyB;QACzB,4BAA4B;QAC5B,4BAA4B;IAChC;;AAEJ;IACI,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;AACzB;;IAEI;QACI,kBAAkB;IACtB;;AAEJ;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,+BAA+B;IAC/B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;;;;;;;;;;;EAWE;;AAEF;IACI,kBAAkB;IAClB,eAAe;IACf,QAAQ;IACR;AACJ;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI;AACJ;;IAEI;QACI,yBAAyB;QACzB,qBAAqB,EAAE,aAAa;IACxC;;AAEJ;IACI,yBAAyB;AAC7B;;AAEA;IACI;AACJ;;IAEI;QACI;IACJ;;AAEJ;IACI;QACI;IACJ;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,+BAA+B;AACnC;;;AAGA,SAAS;AACT;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,SAAS;IACT,SAAS;IACT;AACJ;;AAEA;IACI,WAAW;IACX,cAAc;IACd,QAAQ;IACR,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,aAAa;IACb,UAAU;IACV;AACJ;;IAEI;QACI;IACJ;;IAEA;QACI;IACJ;;AAEJ;IACI,WAAW;IACX,YAAY;IACZ,QAAQ;IACR;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,SAAS;IACT,QAAQ;IACR;AACJ;;AAEA;;;;EAIE;;AAEF;;MAEM;;AAEN;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;IAEI;QACI;IACJ;;;AAGJ;IACI,6BAA6B;IAC7B,UAAU;IACV;AACJ;;AAEA,oBAAoB;;;AAGpB;IACI,gBAAgB;IAChB,gCAAgC;IAChC;AACJ;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;IAC5B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;;;;EAKE;AACF,SAAS;AACT;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;;IAEI,mBAAmB;IACnB;AACJ;;AAEA;;IAEI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;;IAEI,iCAAiC;IACjC,cAAc;AAClB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA4BC;AACD;;;IAGI;AACJ;;AAEA;IACI,wCAAwC;IACxC,0EAA0E;IAC1E,2EAA2E;IAC3E;AACJ;;AAEA;;EAEE;;AAEF;;;;;;EAME;;AAEF;IACI;AACJ;;AAEA,gCAAgC,wCAAwC;IACpE,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI,WAAW;IACX;AACJ;;AAEA;IACI;;4BAEwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,uCAAuC;AAC3C;;IAEI;QACI,wCAAwC;IAC5C;;AAEJ;IACI,oCAAoC;AACxC;;IAEI;QACI,qCAAqC;IACzC;;AAEJ,SAAS;;AAET;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc,EAAE,UAAU;AAC9B;;AAEA;IACI,cAAc;AAClB;;;;AAIA;AACA;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,8BAA8B;AAClC;;AAEA;AACA;;AAEA;AACA;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;AACA;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,8BAA8B;AAClC;;AAEA;AACA;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA;;AAEA;IACI,8BAA8B;AAClC;;AAEA;AACA;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;;AAGA,SAAS;AACT;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA,iBAAiB;AACjB;;;;;;;CAOC;AACD;IACI,yBAAyB;AAC7B;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;;;;;;;;;;;;EAYE;;AAEF;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;IAEI;AACJ;;AAEA;;IAEI;AACJ;;AAEA,SAAS;AACT;IACI,4BAA4B;IAC5B,yBAAyB;IACzB,oCAAoC;IACpC,gDAAgD;IAChD;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI,yCAAyC;IACzC,oCAAoC;IACpC,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;EAGE;;AAEF,OAAO;AACP;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,QAAQ;AACR;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;IAEI;QACI,cAAc;IAClB;;AAEJ;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;AAC7B;;IAEI;QACI,cAAc;QACd,kBAAkB;QAClB,YAAY;QACZ,YAAY;QACZ,WAAW;QACX,kBAAkB;QAClB,WAAW;QACX,mBAAmB;QACnB,gBAAgB;QAChB,kBAAkB;QAClB,mBAAmB;QACnB,gBAAgB;QAChB,uBAAuB;IAC3B;;QAEI;YACI,mBAAmB;YACnB,yBAAyB;QAC7B;;QAEA;YACI,mBAAmB;YACnB,yBAAyB;QAC7B;;QAEA;YACI,mBAAmB;YACnB,yBAAyB;QAC7B;;AAER;IACI,4BAA4B;AAChC;;AAEA;IACI,4EAA4E;AAChF;;AAEA;IACI,4EAA4E;AAChF;;AAEA;IACI,4EAA4E;AAChF;;AAEA;IACI;AACJ;;AAEA;IACI,0DAA0D;AAC9D;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,4BAA4B;AAChC;;IAEI;QACI,cAAc;QACd;IACJ;;AAEJ;;;;;;EAME;;AAEF;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB;AACJ;AACA;;EAEE;AACF,kCAAkC;AAClC,8BAA8B;AAC9B;EACE;AACF;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;IACf,SAAS;AACb;;IAEI;QACI;IACJ;;AAEJ;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;;IAEI;QACI,6CAA6C;QAC7C,yBAAyB;IAC7B;;IAEA;QACI,6CAA6C;QAC7C,yBAAyB;IAC7B;;IAEA;QACI,6CAA6C;QAC7C,yBAAyB;IAC7B;;AAEJ;;EAEE;;AAEF;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,qBAAqB;IACrB,sBAAsB;IACtB,0CAA0C;IAC1C,2CAA2C;AAC/C;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,qBAAqB;IACrB,sBAAsB;IACtB,0CAA0C;IAC1C,2CAA2C;AAC/C;;AAEA;;EAEE;;;AAGF;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;IAEI;AACJ;;;AAGA;IACI;AACJ;;AAEA;;IAEI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,iBAAiB;IACjB,0CAA0C;AAC9C;;IAEI;QACI,+BAA+B;IACnC;;IAEA;QACI,uDAAuD;IAC3D;;AAEJ;IACI,uDAAuD;AAC3D;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI,2BAA2B;IAC3B;AACJ;;AAEA;IACI,UAAU;IACV;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA,gBAAgB,yCAAyC;IACrD,cAAc;IACd,UAAU,EAAE,YAAY;AAC5B;;AAEA,+BAA+B,yCAAyC;IACpE,cAAc;IACd,UAAU,EAAE,YAAY;AAC5B;;AAEA,yBAAyB,4BAA4B;IACjD,cAAc;IACd,UAAU;AACd;;AAEA,wCAAwC,4BAA4B;IAChE,cAAc;IACd,UAAU;AACd;;AAEA,0BAA0B,mBAAmB;IACzC,cAAc;IACd,UAAU;AACd;;AAEA,yCAAyC,mBAAmB;IACxD,cAAc;IACd,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,2CAA2C;AAC/C;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,yCAAyC;IACzC,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,yCAAyC;IACzC,yBAAyB;IACzB,oCAAoC;AACxC;;IAEI;QACI,gCAAgC;QAChC,oCAAoC;QACpC,yBAAyB;IAC7B;;IAEA;QACI,oCAAoC;QACpC,oEAAoE;QACpE,4DAA4D;QAC5D,oCAAoC;QACpC,yBAAyB;IAC7B;;IAEA;QACI,oCAAoC;QACpC,gCAAgC;QAChC,yBAAyB;IAC7B;;AAEJ;IACI,yBAAyB;IACzB,oCAAoC;AACxC;;IAEI;QACI,yBAAyB;QACzB,oCAAoC;IACxC;;AAEJ;IACI,yBAAyB;IACzB,oCAAoC;AACxC;;IAEI;QACI,yBAAyB;QACzB,oCAAoC;IACxC;;AAEJ;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sGAAsG;IACtG,4BAA4B;AAChC;;AAEA;IACI;AACJ;;AAEA;IACI,0CAA0C;IAC1C,iBAAiB;IACjB;AACJ;;IAEI;QACI,kBAAkB;QAClB,yBAAyB;QACzB,6BAA6B;QAC7B,uDAAuD;IAC3D;;AAEJ;IACI,uDAAuD;AAC3D;;AAEA;IACI,iBAAiB;IACjB;AACJ;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;;;;IAII,oCAAoC;IACpC,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,sBAAsB;IACtB,SAAS;IACT,MAAM;IACN,OAAO;IACP,QAAQ;IACR;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,cAAc;IACd,qBAAqB;IACrB,uBAAuB;IACvB,wBAAwB;IACxB,kBAAkB;IAClB,mCAAmC;IACnC,yBAAyB;IACzB,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;;EAEE;;AAEF;IACI,sDAAsD;AAC1D;;;AAGA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,2BAA2B;IAC3B,cAAc;IACd,kBAAkB;IAClB,2BAA2B;IAC3B,cAAc;IACd,SAAS;AACb;;AAEA;IACI,oCAAoC;IACpC,iCAAiC;IACjC,2BAA2B;IAC3B;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,oBAAoB;IACpB,sBAAsB;AAC1B;;IAEI;QACI,gBAAgB;QAChB,cAAc;IAClB;;AAEJ,yTAAyT;AACzT,wCAAwC;AACxC;;EAEE;;AAEF;IACI,wCAAwC;IACxC,iCAAiC;AACrC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,2CAA2C;IAC3C,YAAY;IACZ;AACJ;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB;AACJ;;IAEI;QACI,6BAA6B;IACjC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,6BAA6B;QAC7B,uBAAuB;QACvB,uBAAuB;IAC3B;;IAEA;QACI,6BAA6B;IACjC;;AAEJ;IACI,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,uCAAuC;IACvC,wCAAwC;IACxC,+BAA+B;IAC/B,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,iBAAiB;IACjB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ;AACJ;;IAEI;QACI,sBAAsB;IAC1B;;AAEJ;IACI,aAAa;IACb;AACJ;;IAEI;QACI,mBAAmB;QACnB,gBAAgB;QAChB,YAAY;IAChB;;AAEJ;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;IAEI;QACI,eAAe;QACf;IACJ;;QAEI;YACI;QACJ;;QAEA;YACI,gBAAgB;YAChB,yBAAyB;YACzB,cAAc;YACd,eAAe;QACnB;;QAEA;YACI,gBAAgB;YAChB,yBAAyB;YACzB,cAAc;YACd,cAAc;QAClB;;AAER;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;;AAGA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;AACA,cAAc;AACd;IACI;AACJ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB;AACJ;;IAEI;QACI;IACJ;;AAEJ;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX;;;uBAGmB;AACvB;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,+CAA+C;IAC/C;;;6BAGyB;IACzB,yBAAyB;IACzB,6BAA6B;IAC7B,qBAAqB;IACrB;AACJ;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,wBAAwB,EAAE,aAAa,EAAE,sCAAsC;AACnF;;IAEI;QACI,wDAAwD;IAC5D;;AAEJ;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,yBAAyB,EAAE,oCAAoC;IAC/D,wCAAwC;AAC5C;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;IAC3B,gDAAgD;IAChD,4CAA4C;IAC5C,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;AACnB;;IAEI;QACI,sDAAsD;IAC1D;;AAEJ;IACI,cAAc;IACd,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,wBAAwB;IACxB,wBAAwB;IACxB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI,sBAAsB;IACtB,gCAAgC;IAChC,oCAAoC;AACxC;;AAEA;IACI;AACJ;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI;AACJ;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;;IAEI,qBAAqB;IACrB,gBAAgB;AACpB;;IAEI;;QAEI,wBAAwB;QACxB,iBAAiB;IACrB;;;AAGJ;;IAEI,2BAA2B;IAC3B,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;;IAEI,2BAA2B;IAC3B;AACJ;;;;AAIA;;IAEI,2BAA2B;IAC3B,8BAA8B;IAC9B,iCAAiC;IACjC,6BAA6B;IAC7B,4BAA4B;IAC5B;;KAEC;AACL;;;;;AAKA;IACI,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,2DAA2D;IAC3D,mBAAmB;IACnB,yBAAyB;AAC7B;;IAEI;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,WAAW;QACX,eAAe;QACf,WAAW;QACX,YAAY;QACZ;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI;IACJ;;IAEA;QACI,YAAY;QACZ;IACJ;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI;IACJ;;AAEJ;;IAEI,iBAAiB;IACjB,eAAe;IACf;AACJ;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf;AACJ;;AAEA;IACI,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;;;IAGI,iCAAiC;IACjC,iCAAiC;AACrC;;AAEA;;;IAGI,oCAAoC;IACpC,iCAAiC;AACrC;;AAEA;IACI,oCAAoC;IACpC,gCAAgC;IAChC,8BAA8B;AAClC;;AAEA;;IAEI;AACJ;;AAEA;IACI,gCAAgC;IAChC,iCAAiC;AACrC;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;IACrB,oCAAoC;IACpC,yDAA4U;IAC5U,4BAA4B;IAC5B,2DAA2D;IAC3D,gEAAgE;AACpE;;AAEA;IACI;AACJ;;;;AAIA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd;AACJ;;AAEA;IACI,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,oBAAoB;AACxB;;IAEI;QACI;IACJ;;;;AAIJ;IACI;AACJ;;AAEA;IACI,YAAY;IACZ,8BAA8B;IAC9B;AACJ;;IAEI;;QAEI,UAAU;QACV,oCAAoC;QACpC;IACJ;;;;AAIJ;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;IACzB,iCAAiC;IACjC,6CAA6C;AACjD;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI;AACJ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,0CAA0C;IAC1C,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;;;AAIA;IACI,aAAa;AACjB;;AAEA;IACI;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,cAAc;IACd,aAAa;IACb,0BAA0B;IAC1B,WAAW;AACf;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,SAAS;IACT,mBAAmB;IACnB,6BAA6B;IAC7B,4BAA4B;IAC5B,yBAAyB;IACzB,iCAAiC;IACjC,kCAAkC;IAClC,aAAa;IACb;AACJ;;;;AAIA;IACI,UAAU;IACV;AACJ;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,oCAAoC;AACxC;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI,gBAAgB;IAChB;AACJ;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;AAEA;;EAEE;;AAEF;IACI,yBAAyB;IACzB;gCAC4B;AAChC;;AAEA;IACI,yBAAyB;IACzB;iCAC6B;AACjC;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ;;;AAGA;;;;;EAKE;AACF;IACI;QACI,qBAAqB;QACrB,qBAAqB;QACrB,mBAAmB;IACvB;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,qBAAqB;QACrB,mBAAmB;QACnB;IACJ;AACJ;AACA,iBAAiB;AACjB;;;;;;;;;;;;;;;;;CAiBC;;;AAGD;IACI;QACI,sDAAsD;QACtD,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;;;IAII;QACI;IACJ;;IAEA;QACI,YAAY;IAChB;;QAEI;YACI;QACJ;;IAEJ;QACI,cAAc;IAClB;;IAEA;QACI,yBAAyB;IAC7B;;AAEJ;;AAEA;AACA;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,8BAA8B;QAC9B,4BAA4B;QAC5B,iCAAiC;QACjC,8BAA8B;QAC9B,uBAAuB;IAC3B;;IAEA;QACI,wCAAwC;QACxC;IACJ;;IAEA;QACI,yBAAyB;QACzB,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,2BAA2B;QAC3B,0BAA0B;QAC1B,2BAA2B;QAC3B;IACJ;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;;IAEI;QACI,sBAAsB;QACtB,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,sBAAsB;IAC1B;AACJ;;;AAGA;IACI;QACI;IACJ;;IAEA;QACI,gBAAgB;QAChB,eAAe;QACf,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI;IACJ;;IAEA;;;;;;MAME;;IAEF;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;;AAGA;IACI;QACI;IACJ;;IAEA;QACI,8BAA8B;QAC9B,mBAAmB;QACnB,iCAAiC;QACjC,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,cAAc;IAClB;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI;IACJ;;IAEA;QACI,8BAA8B;QAC9B,mBAAmB;QACnB,iCAAiC;QACjC,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI;IACJ;;IAEA;QACI,qBAAqB;QACrB,cAAc;IAClB;;IAEA;QACI;IACJ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,YAAY;QACZ,kBAAkB,EAAE,QAAQ;QAC5B,kBAAkB;QAClB,6BAA6B,EAAE,4CAA4C;IAC/E;;IAEA;QACI,uBAAuB;QACvB,uBAAuB;QACvB,4BAA4B;IAChC;;;IAGA;QACI,0BAA0B;QAC1B,2BAA2B;IAC/B;IACA;QACI;IACJ;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI;IACJ;;;;AAIJ;;AAEA;;IAEI;QACI,iBAAiB;QACjB,aAAa;QACb,eAAe;QACf,0BAA0B;IAC9B;;IAEA;QACI,uBAAuB;QACvB,uBAAuB;QACvB,4BAA4B;IAChC;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,aAAa;QACb,cAAc;QACd,4BAA4B;IAChC;;IAEA;QACI,uBAAuB;IAC3B;;AAEJ;;AAEA;;IAEI;QACI,iBAAiB;QACjB,aAAa;QACb,eAAe;QACf,0BAA0B;IAC9B;;IAEA;QACI,uBAAuB;QACvB,uBAAuB;QACvB,4BAA4B;IAChC;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,aAAa;QACb,cAAc;QACd,4BAA4B;IAChC;;IAEA;QACI,0BAA0B;QAC1B,+BAA+B;IACnC;;IAEA;QACI,eAAe;IACnB;AACJ;;;AAGA;IACI;QACI,aAAa;QACb,iBAAiB;QACjB,eAAe;QACf,0BAA0B;IAC9B;;IAEA;QACI,4BAA4B;QAC5B,wBAAwB;QACxB,uBAAuB;QACvB,4BAA4B;IAChC;;IAEA;QACI,0CAA0C;QAC1C,YAAY;QACZ,gBAAgB;QAChB,aAAa;QACb,6BAA6B;QAC7B,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["body {\r\n    overflow-x: hidden\r\n}\r\n\r\n.container-fluid-hack {\r\n    padding-left: 1px !important;\r\n    padding-right: 1px !important;\r\n    top: 58px;\r\n    margin-top: 40px;\r\n    /*position: absolute;*/\r\n}\r\n\r\n/*.navbar {\r\n    line-height: normal !important;\r\n    border-bottom: none;\r\n    background: #fff !important;\r\n    padding: .5rem 0rem;\r\n    height: 80px\r\n}*/\r\n\r\n.navbar-brand {\r\n    padding: 0\r\n}\r\n\r\n.white-content .navbar {\r\n    border-bottom: 1px solid #9e9f9f\r\n}\r\n/*.navbar-brand {margin-left: 1em}*/\r\n\r\n.navbar-brand div {\r\n    width: 111px;\r\n    height: 39px;\r\n}\r\n\r\n.navbar-nav {\r\n    /*//margin-left: 3rem*/\r\n}\r\n\r\n    .navbar-nav li {\r\n    }\r\n\r\n.mian-nav li.nav-item {\r\n    padding: 0.15rem 1rem;\r\n    margin: 0 0.5rem;\r\n}\r\n\r\n.mian-nav li.active {\r\n    background: #0079c2;\r\n    border-radius: 25px\r\n}\r\n\r\n.mian-nav .active > .nav-link, .mian-nav .nav-link.active,\r\n.mian-nav .nav-link.show, .mian-nav .show > .nav-link {\r\n    color: #fff !important;\r\n}\r\n\r\n.navbar-dark .navbar-nav .nav-link.active {\r\n    /* color: #495057*/\r\n}\r\n\r\n.navbar-dark .navbar-nav .nav-link {\r\n    color: #333;\r\n    /* font-family: font-m;*/\r\n}\r\n\r\n    .navbar-dark .navbar-nav .nav-link:focus, .navbar-dark .navbar-nav .nav-link:hover {\r\n        /* color: #0079c2;*/\r\n    }\r\n\r\n/*.nav-link {\r\n    font-size: 15px;\r\n}*/\r\n\r\n.nav-pills .nav-link {\r\n    min-width: 120px;\r\n    height: 35px;\r\n    padding: .4rem 1rem;\r\n    border-radius: 25px;\r\n    border: 1px solid #ccc;\r\n    color: black;\r\n    font-weight: 400;\r\n}\r\n\r\n    .nav-pills .nav-link.active, .nav-pills .show > .nav-link {\r\n        background-color: #02a6e5;\r\n        border: 0\r\n    }\r\n\r\n.clearbr:after {\r\n    content: \".\";\r\n    display: block;\r\n    clear: both;\r\n    visibility: hidden;\r\n    line-height: 0;\r\n    height: 0;\r\n}\r\n\r\n#right {   \r\n    /* margin-left: 60%;*/\r\n    /*bottom: 0.5rem;*/\r\n    background: var(--grey-light);\r\n   /* overflow-y: auto;*/\r\n    /*border: 1px solid #ddd;\r\n    width: 30%;*/\r\n}\r\n\r\n\r\n\r\n.bg-green {\r\n    background-color: #10F041\r\n}\r\n\r\n.bg-blue {\r\n    background-color: #0378C9\r\n}\r\n\r\n.bg-white-blue {\r\n    background-color: #8DBFFF\r\n}\r\n\r\n.bg-red {\r\n    background-color: #FF4949\r\n}\r\n\r\n.bg-grey {\r\n    background-color: #DEDEDE\r\n}\r\n\r\n/**************************/\r\n.drawer-handle {\r\n    top: 15px;\r\n    width: 31px;\r\n    height: 30px\r\n}\r\n\r\n.headerCon {\r\n    position: relative;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    top: 0px;\r\n}\r\n\r\n    .headerCon .card-deck .card h5 {\r\n        margin-bottom: 0\r\n    }\r\n\r\n    .headerCon .card-deck .card p {\r\n        margin-bottom: 0\r\n    }\r\n\r\n.egxStats .card .card-body, .statsCon .card .card-body {\r\n    padding: 0.1rem 0.5rem !important;\r\n}\r\n\r\n.mrktDetails {\r\n    display: flex;\r\n    flex-flow: row;\r\n    align-items: center;\r\n}\r\n\r\n    .mrktDetails span, .chart_desc span.num {\r\n        line-height: 1rem;\r\n        margin-bottom: 0;\r\n    }\r\n\r\n        .mrktDetails span[data-field=\"last_time\"] {\r\n            background-image: url(\"data:image/svg+xml,%3Csvg xmlns=\\'http://www.w3.org/2000/svg\\' width=\\'15\\' height=\\'15\\' viewBox=\\'0 0 24 24\\'%3E%3Cpath d=\\'M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm1 12v-6h-2v8h7v-2h-5z\\' fill=\\'%23c7c7c7\\'/%3E%3C/svg%3E\");\r\n            background-repeat: no-repeat;\r\n        }\r\n\r\n        .mrktDetails span[data-field=\"turnover\"],\r\n        .mrktDetails span[data-field=\"volume\"],\r\n        .mrktDetails span[data-field=\"trades\"] {\r\n            font-size: 0.8125rem !important;\r\n            color: #ffffff;\r\n        }\r\n\r\n.white-content .mrktDetails span[data-field=\"turnover\"],\r\n.white-content .mrktDetails span[data-field=\"volume\"],\r\n.white-content .mrktDetails span[data-field=\"trades\"] {\r\n    color: #1d253b;\r\n}\r\n\r\n.white-content .mrktDetails span[data-field=\"last_time\"] {\r\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns=\\'http://www.w3.org/2000/svg\\' width=\\'15\\' height=\\'15\\' viewBox=\\'0 0 24 24\\'%3E%3Cpath d=\\'M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm1 12v-6h-2v8h7v-2h-5z\\' fill=\\'%23717171\\'/%3E%3C/svg%3E\");\r\n    background-repeat: no-repeat;\r\n}\r\n\r\n.mrktDetails label {\r\n    font-weight: 300;\r\n    margin-bottom: 0.4rem;\r\n    /*  background: #fff;\r\n        padding:0.3rem */\r\n}\r\n\r\n.mrktDetails .card-text {\r\n    margin: 0 0.3rem\r\n}\r\n\r\n.card .card-text span[data-field=\"change\"], .card .card-text span[data-field=\"change_percentage\"] {\r\n    font-size: smaller\r\n}\r\n\r\n.fixed-plugin .dropdown-menu {\r\n    color: #fff !important;\r\n    background: linear-gradient(#787777, #808080) !important;\r\n}\r\n\r\n.white-content .fixed-plugin .dropdown-menu {\r\n    color: #9e9f9f; /*background: linear-gradient(#dee2e6, #bdc3c7);*/\r\n    background: linear-gradient(#f1f1f1, #ffffff) !important;\r\n}\r\n\r\n.white-content .fixed-plugin li.header-title,\r\n.white-content .fixed-plugin .adjustments-line .color-label {\r\n    color: #9e9f9f;\r\n}\r\n\r\n.white-content .fixed-plugin .fa {\r\n    color: #525f7f\r\n}\r\n\r\n.white-content .mrktDetails label, .white-content .mrktDetails .lbl {\r\n    color: #717171;\r\n}\r\n\r\n.mrktDetails .card-text {\r\n}\r\n\r\n.mrktDetails .card-text-con {\r\n    margin: 0 0 0 0.5rem;\r\n    display: flex;\r\n    text-align: center;\r\n    line-height: 0.4rem;\r\n}\r\n\r\n    .mrktDetails .card-text-con label {\r\n        display: block\r\n    }\r\n\r\n.statsCon {\r\n    display: inherit;\r\n    padding: 0.3rem\r\n}\r\n\r\n.dropdown-menu {\r\n    font-size: inherit !important\r\n}\r\n/*layout*/\r\n.react-grid-item:not(.react-grid-placeholder) {\r\n    border: 1px solid black;\r\n}\r\n\r\n\r\n.window {\r\n    border: 2px black solid;\r\n    padding: 0px;\r\n    border-radius: 4px;\r\n    box-shadow: 3px 3px 1px gray;\r\n    transition: box-shadow 1s;\r\n    width: 100%;\r\n}\r\n\r\n.window-header {\r\n    margin: 0px;\r\n    height: 20px;\r\n    background-color: #424242;\r\n    padding: 0px 2px;\r\n    font-size: 0.75rem !important;\r\n    cursor: all-scroll\r\n}\r\n\r\n.window-title {\r\n    color: white;\r\n}\r\n\r\n\r\n.window-control {\r\n    color: #b6b6b6 !important;\r\n    float: right;\r\n    position: absolute;\r\n    /* i { cursor: pointer;} */\r\n    /* i.minus {    vertical-align: bottom;}*/\r\n}\r\n\r\n.white-content .window-control {\r\n    color: #969caf !important;\r\n}\r\n\r\n.fl_panel_ld .ctrl_btn {\r\n    color: #b6b6b6 !important;\r\n}\r\n\r\n.white-content .fl_panel_ld > div > div {\r\n    background-color: #cccccc !important;\r\n}\r\n\r\n.white-content .fl_panel_ld li {\r\n    background-color: #f5f7f7 !important;\r\n}\r\n\r\n    .white-content .fl_panel_ld li div div div {\r\n        color: inherit !important;\r\n        text-shadow: none !important;\r\n        font-weight: bold !important;\r\n    }\r\n\r\n.window-content {\r\n    width: 100%;\r\n    top: 20px;\r\n    position: absolute;\r\n    bottom: 0;\r\n    overflow-x: hidden;\r\n    overflow-y: hidden;\r\n    /*font-size: 0.74rem*/\r\n}\r\n\r\n    .window-content .input-group-append {\r\n        width: fit-content;\r\n    }\r\n\r\n.window-statusbar {\r\n    position: absolute;\r\n    bottom: 0px;\r\n    margin: 0px;\r\n    width: 99.7%;\r\n    height: 25px;\r\n    padding: 1px;\r\n    border-top: 1px lightgray solid;\r\n    background: #EEEEEE;\r\n    color: gray;\r\n}\r\n\r\n.window-resize-control {\r\n    cursor: pointer;\r\n}\r\n\r\n.window-resize-control {\r\n    cursor: pointer;\r\n}\r\n\r\n/*.closeIcon {\r\n    position: absolute;\r\n    top: 1px;\r\n    cursor: pointer;\r\n    display: block;\r\n    font-weight: bold;\r\n    padding: 0 0px 1px;\r\n    width: 20px;\r\n    text-align: center;\r\n    border: 1px solid #5d5d5d;\r\n    font-size:0.7rem !important\r\n}*/\r\n\r\n.closeIcon {\r\n    position: absolute;\r\n    cursor: pointer;\r\n    top: 0px;\r\n    font-size: 0.7rem\r\n}\r\n\r\n.white-content .closeIcon {\r\n    //border: 1px solid #a8a8a8;\r\n}\r\n\r\n.react-grid-item.react-grid-placeholder {\r\n    background: grey !important;\r\n}\r\n\r\n.window-control .wms {\r\n    font-size: 0.7rem\r\n}\r\n\r\n    .window-control .wms .nav-link {\r\n        color: #b6b6b6 !important;\r\n        padding: 0 !important; /*.0rem 1rem*/\r\n    }\r\n\r\n.white-content .window-control .wms .nav-link {\r\n    color: #969caf !important;\r\n}\r\n\r\n.wms .dropdown-menu {\r\n    min-width: unset !important\r\n}\r\n\r\n    .wms .dropdown-menu:before {\r\n        display: none\r\n    }\r\n\r\n@media screen and (max-width: 991px) {\r\n    .wms .dropdown-toggle:after {\r\n        display: none\r\n    }\r\n}\r\n\r\n.ag-theme-balham-dark .ag-header-cell::after, .ag-theme-balham-dark .ag-header-group-cell::after {\r\n    background-color: #5a5a5a !important\r\n}\r\n\r\n.ag-theme-balham, .ag-theme-balham-dark {\r\n    font-size: inherit !important;\r\n    font-family: inherit !important;\r\n}\r\n\r\n\r\n/*common*/\r\n.agGridFullSC {\r\n    top: 0px !important;\r\n}\r\n\r\n.agGridPosition {\r\n    width: 100%;\r\n    bottom: 0;\r\n    top: 36px;\r\n    position: absolute\r\n}\r\n\r\n.agGridPositionLev2 {\r\n    width: 100%;\r\n    bottom: 3.75em;\r\n    top: 0px;\r\n    position: absolute;\r\n    margin-bottom: 0.2rem;\r\n}\r\n\r\n.bidsAsksTotals {\r\n    position: absolute;\r\n    bottom: 0;\r\n    display: flex;\r\n    flex: 1 1 50%;\r\n    width: 95%;\r\n    padding: 0 0.1rem\r\n}\r\n\r\n    .bidsAsksTotals .vals {\r\n        width: 50%\r\n    }\r\n\r\n    .bidsAsksTotals label {\r\n        font-size: inherit !important\r\n    }\r\n\r\n.agGridPositionTopten {\r\n    width: 100%;\r\n    bottom: 23px;\r\n    top: 5px;\r\n    position: absolute\r\n}\r\n\r\n.white-content .bidsAsksTotals .vals span {\r\n    color: #333\r\n}\r\n\r\n.agGridPositionInves {\r\n    width: 100%;\r\n    bottom: 0;\r\n    top: 0px;\r\n    position: absolute\r\n}\r\n\r\n/*.quoteListOptionsContainer {\r\n    padding-top: 3px;\r\n    padding-bottom: 4px;\r\n    width: 100%;\r\n}*/\r\n\r\n/* .quoteListOptionsContainer .input-group {\r\n        display: inherit !important\r\n    }*/\r\n\r\n.quoteListOptionsContainer .input-group .btn {\r\n    font-size: 0.75rem;\r\n}\r\n\r\n.searchFilterCon {\r\n    padding-top: 3px;\r\n    padding-bottom: 4px;\r\n    width: 100%;\r\n}\r\n\r\n.quoteListMenu {\r\n    margin: 2px 5px;\r\n}\r\n\r\n    .quoteListMenu select {\r\n        width: 100%\r\n    }\r\n\r\n\r\n.addSymbol {\r\n    position: absolute !important;\r\n    z-index: 5;\r\n    margin-top: -2px\r\n}\r\n\r\n/*Grid agrig Global*/\r\n\r\n\r\n.ag-root-wrapper .ag-cell {\r\n    overflow: hidden;\r\n    padding-left: inherit !important;\r\n    padding-right: inherit !important\r\n}\r\n\r\n.ag-row .ag-cell {\r\n    padding-left: 2px !important;\r\n    padding-right: 2px !important;\r\n}\r\n\r\n.ag-theme-balham .ag-value-change-delta, .ag-theme-balham-dark .ag-value-change-delta {\r\n    padding-right: 0 !important\r\n}\r\n\r\n.ag-react-container div, .ag-react-container span {\r\n    margin: 0 -2px;\r\n    padding-left: 2px !important;\r\n    padding-right: 2px !important;\r\n}\r\n\r\n.ag-cell-label-container {\r\n    width: auto !important;\r\n}\r\n\r\n.ag-root-wrapper .ag-header-cell, .ag-root-wrapper .ag-header-group-cell {\r\n    padding-left: 5px !important;\r\n    padding-right: 5px !important\r\n}\r\n\r\n.ag-root-wrapper .ag-row-drag {\r\n    min-width: inherit !important\r\n}\r\n\r\n.ag-react-container span {\r\n    display: block;\r\n}\r\n\r\n.ag-header-cell {\r\n    display: grid !important;\r\n}\r\n\r\n.ag-header-cell-label {\r\n    justify-content: center !important;\r\n}\r\n\r\n.text-align-right {\r\n    text-align: right\r\n}\r\n\r\n.text-align-center {\r\n    text-align: center\r\n}\r\n\r\n/*.lm_goldenlayout {\r\n    width: 100% !important;\r\n    top: 49px !important;\r\n    bottom: 0 !important;\r\n    position: absolute !important;\r\n}*/\r\n/*tables*/\r\n.ag-body-viewport {\r\n    position: relative;\r\n}\r\n\r\n.ag-root ::-webkit-scrollbar, .fl_panel_ld ::-webkit-scrollbar {\r\n    width: 5px;\r\n    height: 5px;\r\n}\r\n\r\n.ag-root ::-webkit-scrollbar-track-piece, .fl_panel_ld ::-webkit-scrollbar-track-piece {\r\n    background: #000;\r\n    display: block\r\n}\r\n\r\n.white-content .ag-root ::-webkit-scrollbar-track-piece,\r\n.white-content .fl_panel_ld ::-webkit-scrollbar-track-piece {\r\n    background: #dee2e6;\r\n    display: block\r\n}\r\n\r\n.ag-root ::-webkit-scrollbar-thumb,\r\n.fl_panel_ld ::-webkit-scrollbar-thumb {\r\n    background: #7a7a7a;\r\n    display: block;\r\n}\r\n\r\n.white-content .ag-root ::-webkit-scrollbar-thumb,\r\n.white-content .fl_panel_ld ::-webkit-scrollbar-thumb {\r\n    background: #636c83 /* #7a7a7a */;\r\n    display: block;\r\n}\r\n\r\n/*.ag-root ::-webkit-scrollbar {\r\n    width: 5px;    \r\n    height:5px;\r\n    top:0;\r\n    bottom:0;\r\n    position:relative\r\n}\r\n\r\n.ag-root ::-webkit-scrollbar-button {\r\n    background: #333\r\n}\r\n\r\n.ag-root ::-webkit-scrollbar-track-piece {\r\n    background: #888\r\n}\r\n\r\n.ag-root ::-webkit-scrollbar-thumb {\r\n    background: #eee\r\n}\r\n\r\n.ag-root:hover ::-webkit-scrollbar-track-piece {\r\n    background: #000;\r\n    display: block\r\n}\r\n.ag-root:hover ::-webkit-scrollbar-thumb {\r\n    display: block;\r\n}\r\n\r\n*/\r\n?\r\n/*colors*/\r\n.navbar {\r\n    background-color: #1a1e34 !important\r\n}\r\n\r\n.white-content .navbar {\r\n    /*background-color: #dee2e6 !important;*/\r\n    /*background-image: linear-gradient(180deg, #dee2e6, #ffffff) !important;*/\r\n    /*background-image: linear-gradient( 180deg, #dee2e6, #cbced9) !important;*/\r\n    background-image: linear-gradient( 180deg, #f1f3f5, #dce0e5) !important\r\n}\r\n\r\n/*.quoteListOptionsContainer, .toolbar {\r\n    font-size: 0.7rem !important\r\n}*/\r\n\r\n/*.quoteListOptionsContainer {\r\n    background: #2d3436;\r\n}\r\n\r\n.white-content .quoteListOptionsContainer {\r\n    background: #f5f7f7\r\n}*/\r\n\r\n.window-header {\r\n    background-color: #2d3436 !important\r\n}\r\n\r\n.white-content .window-header { /*background-color: #f5f6fa !important;*/\r\n    background-color: #dce0e5 !important;\r\n    border-bottom: 1px solid #d9d9d9;\r\n}\r\n\r\n.react-grid-item:not(.react-grid-placeholder) {\r\n    border: 1px solid #000 !important;\r\n}\r\n\r\n.white-content .react-grid-item:not(.react-grid-placeholder) {\r\n    border: 1px solid #d4d4d4 !important;\r\n}\r\n\r\n.window-title {\r\n    color: #fff;\r\n    font-weight: bold\r\n}\r\n\r\n.white-content .window-title {\r\n    color: #333;\r\n    font-weight: bold\r\n}\r\n\r\n.react-tags__selected-tag {\r\n    /*  color: inherit !important;\r\n    background: #4a4a4a !important;\r\n    border: 1px solid #fff;*/\r\n}\r\n\r\n.white-content .react-tags__selected-tag {\r\n    color: #2d3436 !important;\r\n    background: #F1F1F1 !important;\r\n    border: 1px solid #D1D1D1;\r\n}\r\n\r\n.textselect {\r\n    border-bottom-color: #c7c7c7 !important;\r\n}\r\n\r\n    .textselect:after {\r\n        border-top: 4px solid #c7c7c7 !important;\r\n    }\r\n\r\n.white-content .textselect {\r\n    border-bottom-color: #333 !important;\r\n}\r\n\r\n    .white-content .textselect:after {\r\n        border-top: 4px solid #333 !important;\r\n    }\r\n\r\n/*Quotes*/\r\n\r\n.ag-theme-balham .redColor, .white-content .redColor, .white-content .investorsTbl td .redColor {\r\n    color: #de0000;\r\n}\r\n\r\n.ag-theme-balham .greenColor, .white-content .greenColor, .white-content .investorsTbl td .greenColor {\r\n    color: #21a521;\r\n}\r\n\r\n.ag-theme-balham .blueColor, .white-content .blueColor, .white-content .investorsTbl td .blueColor {\r\n    color: #4343ff;\r\n}\r\n\r\n.ag-theme-balham-dark .redColor, .redColor {\r\n    color: #de0000;\r\n}\r\n\r\n.ag-theme-balham-dark .greenColor, .greenColor {\r\n    color: #21a521; /*#10ff00*/\r\n}\r\n\r\n.ag-theme-balham-dark .blueColor, .blueColor {\r\n    color: #4343ff;\r\n}\r\n\r\n\r\n\r\n.redColor-enter {\r\n}\r\n\r\n.ag-theme-balham-dark .redColor-enter-active {\r\n    background: #ea0a0a !important;\r\n}\r\n\r\n.ag-theme-balham .redColor-enter-active {\r\n    color: #fff;\r\n    background: #de0000 !important;\r\n}\r\n\r\n.redColor-enter-done {\r\n}\r\n\r\n.redColor-exit {\r\n}\r\n\r\n.redColor-exit-active {\r\n    color: inherit !important;\r\n    background: none !important;\r\n}\r\n\r\n.greenColor-enter {\r\n}\r\n\r\n.ag-theme-balham-dark .greenColor-enter-active {\r\n    background: #2cb323 !important;\r\n}\r\n\r\n.ag-theme-balham .greenColor-enter-active {\r\n    color: #fff;\r\n    background: #21a521 !important;\r\n}\r\n\r\n.greenColor-enter-done {\r\n}\r\n\r\n.greenColor-exit-active {\r\n    color: inherit !important;\r\n    background: none !important;\r\n}\r\n\r\n.greenColor-exit-done {\r\n}\r\n\r\n.noColor {\r\n}\r\n\r\n.noColor-enter {\r\n}\r\n\r\n.noColor-enter-active {\r\n    background: inherit !important;\r\n}\r\n\r\n.noColor-enter-done {\r\n}\r\n\r\n.noColor-exit-active {\r\n    background: inherit !important;\r\n}\r\n\r\n.noColor-exit-done {\r\n    background: inherit !important;\r\n}\r\n\r\n.boldFont-enter {\r\n    font-weight: bolder !important;\r\n}\r\n\r\n.boldFont-enter-active {\r\n    font-weight: bolder !important;\r\n}\r\n\r\n.boldFont-enter-done {\r\n    font-weight: normal !important;\r\n}\r\n\r\n.boldFont-exit {\r\n    font-weight: normal;\r\n}\r\n\r\n\r\n/*trades*/\r\n.ag-theme-balham .flag-a-trade {\r\n    background-color: #d2efd2 !important;\r\n}\r\n\r\n.ag-theme-balham .flag-b-trade {\r\n    background-color: #f5d6d6 !important;\r\n}\r\n\r\n.ag-theme-balham-dark .flag-a-trade {\r\n    background-color: #205220 !important;\r\n}\r\n\r\n.ag-theme-balham-dark .flag-b-trade {\r\n    background-color: #651818 !important;\r\n}\r\n\r\n/*detailed Quote*/\r\n/*.table-responsive, .table-responsive-sm {\r\n    background-color: #2d3436\r\n}\r\n\r\n.white-content .table-responsive, .white-content .table-responsive-sm {\r\n    background-color: #fff\r\n}\r\n*/\r\n.detailedQuote td, .tble td {\r\n    padding: 2px 0 !important;\r\n}\r\n\r\n.tble td {\r\n    text-align: right\r\n}\r\n\r\n.investorsTbl td {\r\n    padding-right: 4px !important;\r\n    border: 1px solid #5a5a5a;\r\n}\r\n\r\n.investorsTbl tr {\r\n    color: #F5F5F5\r\n}\r\n\r\n.white-content .investorsTbl tr {\r\n    color: #000\r\n}\r\n\r\n.white-content .investorsTbl td {\r\n    padding-right: 4px !important;\r\n    border: 1px solid #d9dcde;\r\n}\r\n\r\n/*.tble td.head {\r\n    font-weight: bold;\r\n    text-align: center;\r\n    border: 1px solid #5a5a5a;\r\n    background: #1c1c1c;\r\n    color: rgba(245, 245, 245, 0.64)\r\n}\r\n\r\n.white-content .tble td.head {\r\n    border: 1px solid #d9dcde;\r\n    background: #f5f7f7;\r\n    color: rgba(0, 0, 0, 0.54)\r\n}*/\r\n\r\n.detailedQuote .A td {\r\n    background-color: #205220 !important;\r\n}\r\n\r\n.detailedQuote .B td {\r\n    background-color: #651818 !important;\r\n}\r\n\r\n.white-content .detailedQuote .A td {\r\n    background-color: #d2efd2 !important;\r\n}\r\n\r\n.white-content .detailedQuote .B td {\r\n    background-color: #f5d6d6 !important;\r\n}\r\n\r\n.up td[data-field=\"CHANGE\"], .up td[data-field=\"CHANGE_PERCENTAGE\"],\r\n.up td[data-field=\"LAST\"], .up p, .openedStyle {\r\n    color: #21a521 !important;\r\n}\r\n\r\n.down td[data-field=\"CHANGE\"], .down td[data-field=\"CHANGE_PERCENTAGE\"],\r\n.down td[data-field=\"LAST\"], .down p, .closedStyle {\r\n    color: #de0000 !important\r\n}\r\n\r\n.middle td[data-field=\"CHANGE\"], .middle td[data-field=\"CHANGE_PERCENTAGE\"],\r\n.middle td[data-field=\"LAST\"], .middle p {\r\n    color: #4343ff !important\r\n}\r\n\r\n.white-content .up td[data-field=\"CHANGE\"], .white-content .up td[data-field=\"CHANGE_PERCENTAGE\"],\r\n.white-content .up td[data-field=\"LAST\"], .white-content .up p, .white-content .openedStyle {\r\n    color: #21a521 !important;\r\n}\r\n\r\n.white-content .down td[data-field=\"CHANGE\"], .white-content .down td[data-field=\"CHANGE_PERCENTAGE\"],\r\n.white-content .down td[data-field=\"LAST\"], .white-content .down p, .white-content .closedStyle {\r\n    color: #de0000 !important\r\n}\r\n\r\n.white-content .middle td[data-field=\"CHANGE\"], .white-content .middle td[data-field=\"CHANGE_PERCENTAGE\"],\r\n.white-content .middle td[data-field=\"LAST\"], .white-content .middle p {\r\n    color: #4343ff !important\r\n}\r\n\r\n/*topten*/\r\n.agGridPositionTopten .nav-tabs .nav-link.active, .agGridPositionTopten .nav-tabs .nav-item.show .nav-link {\r\n    font-weight: bold !important;\r\n    color: #c3c3c3 !important;\r\n    background-color: #2d3436 !important;\r\n    border-color: #e3e3e3 #e3e3e3 #2f2f33 !important;\r\n    border-bottom: none !important\r\n}\r\n\r\n.agGridPositionTopten .nav-tabs .nav-item {\r\n    color: inherit\r\n}\r\n\r\n.white-content .agGridPositionTopten .nav-tabs .nav-item.show .nav-link,\r\n.white-content .agGridPositionTopten .nav-tabs .nav-link.active {\r\n    /* background-color: #f5f7f7 !important;*/\r\n    background-color: #d2d5de !important;\r\n    color: #333 !important;\r\n}\r\n\r\n.agGridPositionTopten .nav-tabs {\r\n    background: #2d3436;\r\n    margin-top: -4px;\r\n}\r\n\r\n.white-content .agGridPositionTopten .nav-tabs {\r\n    background: #fff;\r\n}\r\n\r\n/*a {\r\n    color: #00b0ff !important;\r\n    font-weight: bold !important;\r\n}*/\r\n\r\n/*news*/\r\n.news {\r\n    background: #2d3436;\r\n}\r\n\r\n.white-content .news {\r\n    background: #f5f6fa;\r\n}\r\n\r\n/*chart*/\r\n.chart {\r\n    background: #4d4e4e;\r\n}\r\n\r\n.white-content .chart {\r\n    background: #d2d5de;\r\n}\r\n\r\n.white-content .chart {\r\n    background: #c4c8d1;\r\n}\r\n\r\n.chart_desc {\r\n    width: 150px;\r\n}\r\n\r\n    .chart_desc span {\r\n        display: block;\r\n    }\r\n\r\n.chartbg {\r\n    width: 128px;\r\n    height: 20px;\r\n    background: #e7e7e7;\r\n    border: 1px solid #d9d8d8;\r\n}\r\n\r\n    .chartbg em {\r\n        display: block;\r\n        position: absolute;\r\n        width: 124px;\r\n        height: 18px;\r\n        z-index: 10;\r\n        text-align: center;\r\n        color: #FFF;\r\n        font-size: xx-small;\r\n        padding-top: 2px;\r\n        font-style: normal;\r\n        white-space: nowrap;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n    }\r\n\r\n        .chartbg em.advance {\r\n            background: #2cb323;\r\n            border: 1px solid #2cb323;\r\n        }\r\n\r\n        .chartbg em.declining {\r\n            background: #d63d3d;\r\n            border: 1px solid #ff5151;\r\n        }\r\n\r\n        .chartbg em.unchanged {\r\n            background: #2c9dec;\r\n            border: 1px solid #4343ff;\r\n        }\r\n\r\n.news .btn, .news select, .trades .btn, .trades select, .quoteListOptionsContainer .input-group .btn {\r\n    font-size: 0.8rem !important;\r\n}\r\n\r\n.orange .drawer-handle, .orange .drawer-content-wrapper {\r\n    background-image: linear-gradient(to bottom left, #ff8d72, #fd5d93, #ff8d72);\r\n}\r\n\r\n.primary .drawer-handle, .primary .drawer-content-wrapper {\r\n    background-image: linear-gradient(to bottom left, #e14eca, #ba54f5, #e14eca);\r\n}\r\n\r\n.blue .drawer-handle, .blue .drawer-content-wrapper {\r\n    background-image: linear-gradient(to bottom left, #344675, #263148, #344675);\r\n}\r\n\r\n.blue2 .drawer-handle, .blue2 .drawer-content-wrapper {\r\n    background-image: linear-gradient(0deg,#3358f4,#1d8cf8)\r\n}\r\n\r\n.green .drawer-handle, .green .drawer-content-wrapper {\r\n    background-image: linear-gradient( 2deg, #0098f0, #00f2c3);\r\n}\r\n\r\n.drawer-handle-icon, .drawer-handle-icon:before, .drawer-handle-icon:after {\r\n    background: #fff\r\n}\r\n\r\n.drawer-content-wrapper a {\r\n    color: #fff;\r\n    font-weight: bold !important;\r\n}\r\n\r\n    .drawer-content-wrapper a:hover, .drawer-content-wrapper a:visited {\r\n        color: #EEEEEE;\r\n        text-decoration: underline\r\n    }\r\n\r\n/*.dropdown-menu {\r\n    background-color: #444444 !important\r\n}\r\n\r\n.dropdown {\r\n    font-size: 0.8rem\r\n}*/\r\n\r\n.dropdown-item {\r\n    font-weight: 600;\r\n    text-align: justify;\r\n}\r\n\r\n.sub-dropdown-item > a {\r\n    color: #212529 !important;\r\n    font-weight: bold;\r\n    padding: 0.25rem 0.1rem\r\n}\r\n/*.white-content .dropdown-menu {\r\n    background-color: #f5f6fa !important\r\n}*/\r\n/*.white-content .dropdown-item {*/\r\n/* color: #525f7f !important;*/\r\n/*font-weight: bold !important;\r\n}*/\r\n.agGridBackGround {\r\n    background: #1c1c1c\r\n}\r\n\r\n.white-content .agGridBackGround {\r\n    background: #f5f7f7\r\n}\r\n\r\n.connFlags {\r\n    width: 125px;\r\n    display: block;\r\n    position: fixed;\r\n    top: 12px;\r\n}\r\n\r\n    .connFlags div:last-child {\r\n        margin-top: 0.2rem\r\n    }\r\n\r\n.circle {\r\n    width: 12px;\r\n    height: 12px;\r\n    border-radius: 50%;\r\n    margin-top: 0.12rem;\r\n}\r\n\r\n    .circle.disconnection {\r\n        background: radial-gradient(#e21515,#9e0000 );\r\n        border: 1px solid #ff0012;\r\n    }\r\n\r\n    .circle.connecting {\r\n        background: radial-gradient(#fff42b,#a59b04 );\r\n        border: 1px solid #f4ff00;\r\n    }\r\n\r\n    .circle.connected {\r\n        background: radial-gradient(#2cb323,#14920b );\r\n        border: 1px solid #45f939;\r\n    }\r\n\r\n/*.react-resizable-handle {\r\n    background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 6 6' style='background-color:%23ffffff00' x='0px' y='0px' width='9px' height='9px'%3E%3Cg opacity='0.8'%3E%3Cpath d='M 6 6 L 0 6 L 0 4.2 L 4 4.2 L 4.2 4.2 L 4.2 0 L 6 0 L 6 6 L 6 6 Z' fill='%23ffffff'/%3E%3C/g%3E%3C/svg%3E\") !important;\r\n}*/\r\n\r\n.react-grid-item > .react-resizable-handle::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    right: 3px;\r\n    bottom: 3px;\r\n    width: 7px !important;\r\n    height: 7px !important;\r\n    border-right: 2px solid #c7c7c7 !important;\r\n    border-bottom: 2px solid #c7c7c7 !important;\r\n}\r\n\r\n.white-content .react-grid-item > .react-resizable-handle::after {\r\n    content: \"\";\r\n    position: absolute;\r\n    right: 3px;\r\n    bottom: 3px;\r\n    width: 7px !important;\r\n    height: 7px !important;\r\n    border-right: 2px solid #3c75ff !important;\r\n    border-bottom: 2px solid #2a5bd5 !important;\r\n}\r\n\r\n/*.white-content .react-resizable-handle {\r\n    background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2IDYiIHN0eWxlPSJiYWNrZ3JvdW5kLWNvbG9yOiNmZmZmZmYwMCIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI2cHgiIGhlaWdodD0iNnB4Ij48ZyBvcGFjaXR5PSIwLjMwMiI+PHBhdGggZD0iTSA2IDYgTCAwIDYgTCAwIDQuMiBMIDQgNC4yIEwgNC4yIDQuMiBMIDQuMiAwIEwgNiAwIEwgNiA2IEwgNiA2IFoiIGZpbGw9IiMwMDAwMDAiLz48L2c+PC9zdmc+') !important;\r\n}*/\r\n\r\n\r\n.detailedQuote.table, .detailedQuote .table {\r\n    color: #F5F5F5 !important\r\n}\r\n\r\n.white-content .detailedQuote.table, .white-content .detailedQuote .table {\r\n    color: #000 !important\r\n}\r\n\r\n.detailedQuote .table > tbody > tr > td, .detailedQuote .table > tbody > tr > td:nth-child(odd),\r\n.detailedQuote > tbody > tr > td:nth-child(even) {\r\n    color: #F5F5F5\r\n}\r\n\r\n\r\n.detailedQuote[data-source=\"Quotes\"] tr:nth-child(1) td {\r\n    color: #F5F5F5\r\n}\r\n\r\n.white-content .detailedQuote .table > tbody > tr > td,\r\n.white-content .detailedQuote > tbody > tr > td:nth-child(even) {\r\n    color: #000\r\n}\r\n\r\n.white-content .detailedQuote .table > tbody > tr > td {\r\n    color: #000\r\n}\r\n\r\n.white-content .detailedQuote[data-source=\"Quotes\"] tr:nth-child(1) td {\r\n    color: #000\r\n}\r\n\r\n.bottomPart {\r\n    text-align: right;\r\n    box-shadow: 0 1px 4px 0px rgb(123,123,123);\r\n}\r\n\r\n    .bottomPart tr td {\r\n        padding-right: 0.2em !important;\r\n    }\r\n\r\n    .bottomPart table tr th {\r\n        background-image: linear-gradient(0deg,#000000,#2f2f2f);\r\n    }\r\n\r\n.white-content .bottomPart table tr th {\r\n    background-image: linear-gradient(0deg,#e8e8e8,#e2e2e2);\r\n}\r\n\r\n.white-content .modal .modal-header .close {\r\n    color: #b3b3b3 !important;\r\n}\r\n\r\n.aboutus {\r\n    width: 99% !important;\r\n    padding: 0.2rem;\r\n    direction: rtl;\r\n    color: #fff;\r\n    font-size: smaller;\r\n    text-align: center\r\n}\r\n\r\n.sysAlert h4, .sysAlert .h4 {\r\n    margin-bottom: 0 !important;\r\n    line-height: inherit !important\r\n}\r\n\r\n.sysAlert-con {\r\n    width: 50%;\r\n    margin: 0 auto\r\n}\r\n\r\n.white-content .sysAlert-con p {\r\n    color: rgba(255, 255, 255, 0.8) !important\r\n}\r\n\r\n.snDiv {\r\n    text-align: center;\r\n    padding: 0.2rem;\r\n    white-space: nowrap\r\n}\r\n\r\n.dropdown-menu:before {\r\n    color: #444444 !important\r\n}\r\n\r\n.white-content .dropdown-menu:before {\r\n    color: #f5f6fa !important\r\n}\r\n\r\n::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */\r\n    color: #c7c7c7;\r\n    opacity: 1; /* Firefox */\r\n}\r\n\r\n.white-content ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */\r\n    color: #555555;\r\n    opacity: 1; /* Firefox */\r\n}\r\n\r\n:-ms-input-placeholder { /* Internet Explorer 10-11 */\r\n    color: #c7c7c7;\r\n    opacity: 1;\r\n}\r\n\r\n.white-content :-ms-input-placeholder { /* Internet Explorer 10-11 */\r\n    color: #555555;\r\n    opacity: 1;\r\n}\r\n\r\n::-ms-input-placeholder { /* Microsoft Edge */\r\n    color: #c7c7c7;\r\n    opacity: 1;\r\n}\r\n\r\n.white-content ::-ms-input-placeholder { /* Microsoft Edge */\r\n    color: #555555;\r\n    opacity: 1;\r\n}\r\n\r\n.font-size-changer-buttons .btn {\r\n    padding: 0 !important;\r\n    margin-left: 0 !important;\r\n}\r\n\r\n.introjs-tooltip {\r\n    font-size: 15px;\r\n}\r\n\r\n.introjs-tooltip-header {\r\n    padding: 10px !important;\r\n    border-bottom: 1px solid #616161 !important;\r\n}\r\n\r\n.white-content .introjs-tooltip-header {\r\n    border-bottom-color: #e0e0e0 !important;\r\n}\r\n\r\n.introjs-tooltipbuttons {\r\n    border-top: 1px solid #616161 !important;\r\n}\r\n\r\n.white-content .introjs-tooltipbuttons {\r\n    border-top: 1px solid #e0e0e0 !important;\r\n}\r\n\r\n.introjs-skipbutton {\r\n    padding: 7px 0px !important;\r\n}\r\n\r\n.fontSCHighlightClass {\r\n    margin-top: 20px;\r\n}\r\n\r\n.introjs-tooltip {\r\n    background-color: #2b2b2b !important;\r\n}\r\n\r\n.white-content .introjs-tooltip {\r\n    background-color: #ffffff !important;\r\n}\r\n\r\n.introjs-button {\r\n    border: 1px solid #616161 !important;\r\n    text-shadow: 1px 1px 0 #323232 !important;\r\n    color: #d0d0d0 !important;\r\n    background-color: #484747 !important;\r\n}\r\n\r\n.white-content .introjs-button {\r\n    border: 1px solid #bdbdbd !important;\r\n    text-shadow: 1px 1px 0 #ffffff !important;\r\n    color: #424242 !important;\r\n    background-color: #f4f4f4 !important;\r\n}\r\n\r\n    .white-content .introjs-button:hover {\r\n        border-color: #9e9e9e !important;\r\n        background-color: #e0e0e0 !important;\r\n        color: #212121 !important;\r\n    }\r\n\r\n    .white-content .introjs-button:focus {\r\n        background-color: #eeeeee !important;\r\n        -webkit-box-shadow: 0 0 0 0.2rem rgba(158, 158, 158, 0.5) !important;\r\n        box-shadow: 0 0 0 0.2rem rgba(158, 158, 158, 0.5) !important;\r\n        border: 1px solid #616161 !important;\r\n        color: #212121 !important;\r\n    }\r\n\r\n    .white-content .introjs-button:active {\r\n        background-color: #e0e0e0 !important;\r\n        border-color: #9e9e9e !important;\r\n        color: #212121 !important;\r\n    }\r\n\r\n.introjs-disabled {\r\n    color: #4e4e4e !important;\r\n    background-color: #2f2f2f !important;\r\n}\r\n\r\n    .introjs-disabled:hover, .introjs-disabled:focus {\r\n        color: #4e4e4e !important;\r\n        background-color: #2f2f2f !important;\r\n    }\r\n\r\n.white-content .introjs-disabled {\r\n    color: #9e9e9e !important;\r\n    background-color: #f4f4f4 !important;\r\n}\r\n\r\n    .white-content .introjs-disabled:hover, .white-content .introjs-disabled:focus {\r\n        color: #9e9e9e !important;\r\n        background-color: #f4f4f4 !important;\r\n    }\r\n\r\n.introjs-skipbutton {\r\n    color: #c7c7c7 !important;\r\n}\r\n\r\n.white-content .introjs-skipbutton {\r\n    color: #616161;\r\n}\r\n\r\n.introjs-helperLayer {\r\n    box-shadow: rgba(33, 33, 33, 0.8) 0px 0px 1px 2px, rgba(33, 33, 33, 0.7) 0px 0px 0px 5000px !important;\r\n    border: 1px solid !important;\r\n}\r\n\r\n.bidsCon > tbody > tr, .asksCon > tbody > tr {\r\n    cursor: default\r\n}\r\n\r\n.bidsConDetails {\r\n    color: rgba(255, 255, 255, 0.7) !important;\r\n    max-height: 300px;\r\n    overflow-y: auto\r\n}\r\n\r\n    .bidsConDetails th {\r\n        text-align: center;\r\n        padding: 5px 0 !important;\r\n        font-size: inherit !important;\r\n        background-image: linear-gradient(0deg,#000000,#2f2f2f);\r\n    }\r\n\r\n.white-content .bidsConDetails th {\r\n    background-image: linear-gradient(0deg,#e8e8e8,#e2e2e2);\r\n}\r\n\r\n.bidsConDetails td {\r\n    text-align: right;\r\n    padding: 1px 5px 1px 1px !important\r\n}\r\n\r\n.white-content .bidsConDetails {\r\n    color: rgba(255, 255, 255, 0.7) !important;\r\n}\r\n\r\n.alert-danger .btn-outline-danger:hover, .alert-danger .btn-outline-danger:focus, .alert-danger .btn-outline-danger:active, .alert-danger .btn-outline-danger.active, .alert-danger .btn-outline-danger:active:focus, .alert-danger .btn-outline-danger:active:hover, .alert-danger .btn-outline-danger.active:focus, .alert-danger .btn-outline-danger.active:hover,\r\n.navbar .navbar-nav > a.alert-danger .btn-outline-danger:hover, .navbar .navbar-nav > a.alert-danger .btn-outline-danger:focus, .navbar .navbar-nav > a.alert-danger .btn-outline-danger:active,\r\n.navbar .navbar-nav > a.alert-danger .btn-outline-danger.active, .navbar .navbar-nav > a.alert-danger .btn-outline-danger:active:focus, .navbar .navbar-nav > a.alert-danger .btn-outline-danger:active:hover,\r\n.navbar .navbar-nav > a.alert-danger .btn-outline-danger.active:focus, .navbar .navbar-nav > a.alert-danger .btn-outline-danger.active:hover {\r\n    background-color: #920707 !important;\r\n    background-image: none !important;\r\n}\r\n\r\n.spinerLoadingDiv {\r\n    display: flex;\r\n    justify-content: center;\r\n    vertical-align: middle;\r\n    align-items: center;\r\n    height: inherit;\r\n    position: absolute;\r\n    z-index: 3;\r\n    background-color: #fff;\r\n    bottom: 0;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    margin: 0 0.9rem\r\n}\r\n\r\n.white-content .spinerLoadingDiv {\r\n    background-color: #f5f7f7;\r\n}\r\n\r\n.connected .elementConAni, .connecting .elementConAni {\r\n    display: none\r\n}\r\n\r\n.elementConAni {\r\n    display: block;\r\n    position: absolute;\r\n    height: 20px;\r\n    width: 20px;\r\n    margin: 0 auto;\r\n    background-color: red;\r\n    animation-name: stretch;\r\n    animation-duration: 0.5s;\r\n    animation-delay: 0;\r\n    animation-iteration-count: infinite;\r\n    animation-fill-mode: none;\r\n    animation-play-state: running;\r\n    margin-top: -5px !important;\r\n}\r\n\r\n/*.navbar .card {\r\n    box-shadow: 0 1px 15px 0px rgb(84, 84, 84) !important\r\n}*/\r\n\r\n.white-content .navbar .card {\r\n    box-shadow: 0 1px 15px 0 rgb(244, 245, 246) !important;\r\n}\r\n\r\n\r\n.far:before {\r\n    display: block\r\n}\r\n\r\n.add-modu button.iconbtn {\r\n    padding: 0 !important;\r\n    background: none !important;\r\n    color: #9e9f9f;\r\n    margin-right: 10px;\r\n    font-size: 1.6em !important;\r\n    display: block;\r\n    border: 0;\r\n}\r\n\r\n.add-modu button:active, .add-modu button:focus, .add-modu button:hover {\r\n    background-color: inherit !important;\r\n    background-image: none !important;\r\n    background: none !important;\r\n    color: #bfbfbf !important\r\n}\r\n\r\n.white-content .add-modu button:active, .white-content .add-modu button:focus, .white-content .add-modu button:hover {\r\n    color: #525f7f !important\r\n}\r\n\r\n.fixed-plugin {\r\n    top: 19px !important;\r\n    width: 30px !important;\r\n}\r\n\r\n    .fixed-plugin .fa-bars {\r\n        font-size: 1.5em;\r\n        color: #9e9f9f;\r\n    }\r\n\r\n/*.white-content .btn-primary:hover, .white-content .btn-primary:focus, .white-content .btn-primary:active, .white-content .btn-primary.active, .white-content .btn-primary:active:focus, .white-content .btn-primary:active:hover, .white-content .btn-primary.active:focus, .white-content .btn-primary.active:hover {*/\r\n/*background-color: inherit !important;*/\r\n/*background-image: none !important;\r\n    border: none !important\r\n}*/\r\n\r\n.btn-primary:hover, .btn-primary:focus, .btn-primary:active, .btn-primary.active, .btn-primary:active:focus, .btn-primary:active:hover, .btn-primary.active:focus, .btn-primary.active:hover {\r\n    /*background-color: inherit !important;*/\r\n    background-image: none !important;\r\n}\r\n\r\n|.fixed-plugin .dropdown .dropdown-menu:after {\r\n    border-left: 0.4em solid #787777 !important;\r\n}\r\n\r\n.white-content .fixed-plugin .dropdown .dropdown-menu:after {\r\n    border-left: 0.4em solid #f1f1f1 !important;\r\n    right: -16px;\r\n    top: -41px\r\n}\r\n\r\n.fixed-plugin .dropdown .dropdown-menu:after {\r\n    border-left: 0.4em solid #7a7a7a !important;\r\n}\r\n\r\n.fixed-plugin .dropdown-menu li {\r\n    padding: 5px 2px !important;\r\n}\r\n\r\n.loginFrm .form-control {\r\n    border-color: #9c9c9c !important;\r\n}\r\n\r\n.hg-theme-default {\r\n    margin-top: 10px;\r\n    color: #2d3436\r\n}\r\n\r\n    .hg-theme-default .hg-row:not(:last-child) {\r\n        margin-bottom: 1px !important;\r\n    }\r\n\r\n    .hg-theme-default .hg-row .hg-button:not(:last-child) {\r\n        margin-right: 1px !important;\r\n    }\r\n\r\n    .hg-theme-default .hg-button.hg-standardBtn {\r\n        width: inherit !important;\r\n    }\r\n\r\n    .hg-theme-default .hg-button {\r\n        border-radius: 0px !important;\r\n        height: 30px !important;\r\n        padding: 5px !important;\r\n    }\r\n\r\n    .hg-theme-default .hg-row:not(:last-child) {\r\n        margin-bottom: 1px !important;\r\n    }\r\n\r\n.lm_header .lm_tab {\r\n    padding-left: 2px !important;\r\n    padding-right: 14px !important;\r\n}\r\n\r\n.agGridPositionTopten .nav-tabs .nav-link {\r\n    border-top-left-radius: 0rem !important;\r\n    border-top-right-radius: 0rem !important;\r\n    padding: .2rem .2rem !important;\r\n    border-bottom: none;\r\n    font-weight: bold;\r\n    margin-bottom: -2.0px;\r\n    margin-right: 2px;\r\n    font-family: Arial,sans-serif;\r\n    font-size: 12px;\r\n}\r\n\r\n.white-content .nav-tabs .nav-link {\r\n    border: 1px solid #cccccc;\r\n}\r\n\r\n.appMenu .dropdown-menu a.dropdown-item {\r\n    padding: 0 !important;\r\n    margin: 0 !important;\r\n}\r\n\r\n.appMenu .dropdown-menu a i {\r\n    margin-right: 0;\r\n    font-size: 0.9rem\r\n}\r\n\r\n.appMenu ul {\r\n    margin-bottom: 0;\r\n}\r\n\r\n.wl-quotes-container {\r\n    display: flex;\r\n    flex-direction: row;\r\n    flex-wrap: wrap;\r\n    overflow-y: auto;\r\n    height: 100%;\r\n    min-height: 0px;\r\n    background: #000;\r\n    align-content: flex-start;\r\n}\r\n\r\n.white-content .wl-quotes-container {\r\n    background: #f5f6fa\r\n}\r\n\r\n.wl-item1 {\r\n    grid-area: h;\r\n}\r\n\r\n.wl-item2 {\r\n    grid-area: ml;\r\n    //border: 2px solid;\r\n    padding: 0.3em;\r\n    width: 2.9em;\r\n    text-align: center !important\r\n}\r\n\r\n    .wl-item2 i {\r\n        vertical-align: middle;\r\n    }\r\n\r\n.wl-item3 {\r\n    grid-area: md;\r\n    color: white\r\n}\r\n\r\n    .wl-item3 strong:first-child span:nth-child(2) {\r\n        background: #2c354e;\r\n        font-size: 1.2em;\r\n        padding: 2px;\r\n    }\r\n\r\n.white-content .wl-item3 strong:first-child span:nth-child(2) {\r\n    background: #eee\r\n}\r\n\r\n.white-content .wl-item3 {\r\n    color: black\r\n}\r\n\r\n.wl-item4 {\r\n    grid-area: f;\r\n    text-align: center;\r\n}\r\n\r\n    .wl-item4 button {\r\n        font-size: 11px;\r\n        font-weight: normal\r\n    }\r\n\r\n        .wl-item4 button:hover {\r\n            color: #fff !important\r\n        }\r\n\r\n        .wl-item4 button.buy-btn {\r\n            background: none;\r\n            border: 1px solid #007bff;\r\n            color: #007bff;\r\n            margin-right: 0;\r\n        }\r\n\r\n        .wl-item4 button.sell-btn {\r\n            background: none;\r\n            border: 1px solid #c758a6;\r\n            color: #c758a6;\r\n            margin-left: 0;\r\n        }\r\n\r\n.white-content .wl-item4 button.buy-btn {\r\n    border: 1px solid #0000ff;\r\n    color: #0000ff;\r\n}\r\n\r\n.white-content .wl-item4 button.sell-btn {\r\n    border: 1px solid #b5007f;\r\n    color: #b5007f;\r\n}\r\n\r\n\r\n.wl-quote strong {\r\n    white-space: nowrap\r\n}\r\n\r\n.wl-quote.up strong.numbs, .wl-quote.up .wl-item2 .fas {\r\n    color: #21a521\r\n}\r\n\r\n.wl-quote.down strong.numbs, .wl-quote.down .wl-item2 .fas {\r\n    color: #de0000;\r\n}\r\n\r\n.wl-quote.middle strong.numbs, .wl-quote.middle .wl-item2 .fas {\r\n    color: #4343ff;\r\n}\r\n\r\n.wl-quote.up, .wl-quote.up .wl-item2 {\r\n    border-color: #21a521\r\n}\r\n\r\n.wl-quote.down, .wl-quote.down .wl-item2 {\r\n    border-color: #de0000\r\n}\r\n\r\n.wl-quote.middle, .wl-quote.middle .wl-item2 {\r\n    border-color: #4343ff\r\n}\r\n/*************/\r\n.white-content .wl-quote.up strong.numbs, .white-content .wl-quote.up .wl-item2 .fas {\r\n    color: #21a521\r\n}\r\n\r\n.white-content .wl-quote.down strong.numbs, .white-content .wl-quote.down .wl-item2 .fas {\r\n    color: #de0000;\r\n}\r\n\r\n.white-content .wl-quote.middle strong.numbs, .white-content .wl-quote.middle .wl-item2 .fas {\r\n    color: #4343ff;\r\n}\r\n\r\n.white-content .wl-quote.up, .white-content .wl-quote.up .wl-item2 {\r\n    border-color: #21a521\r\n}\r\n\r\n.white-content .wl-quote.down, .white-content .wl-quote.down .wl-item2 {\r\n    border-color: #de0000\r\n}\r\n\r\n.white-content .wl-quote.middle, .white-content .wl-quote.middle .wl-item2 {\r\n    border-color: #4343ff\r\n}\r\n\r\n.c-time-con {\r\n    width: 100%;\r\n    height: inherit;\r\n    padding-top: 1rem;\r\n}\r\n\r\n.c-time {\r\n    text-align: center;\r\n    font-size: larger;\r\n    font-weight: bold;\r\n    margin: 0.5rem 0\r\n}\r\n\r\n    .c-time strong {\r\n        color: #fff\r\n    }\r\n\r\n.white-content .c-time strong {\r\n    color: #000\r\n}\r\n\r\n.react-countdown-clock {\r\n    margin: 0 auto\r\n}\r\n\r\n.white-content .indx-con {\r\n    background: #fff;\r\n}\r\n\r\n.indx-con hr {\r\n    margin-top: 0.5rem;\r\n    margin-bottom: 0.5rem;\r\n}\r\n\r\n.indx-con .indx-val {\r\n    font-size: 1.2em;\r\n    font-weight: 600\r\n}\r\n\r\n.indx-row {\r\n    padding-top: 0.7em;\r\n}\r\n\r\n.indx-wrapper {\r\n    display: grid;\r\n    /*grid-gap: 10px;*/\r\n    grid-template-columns: 30px 150px;\r\n    align-items: center;\r\n}\r\n\r\n.indx-a {\r\n    grid-column: 1 / 2;\r\n    grid-row: 1 / 3;\r\n}\r\n\r\n.indx-b {\r\n    grid-column: 2;\r\n    grid-row: 1 / 2;\r\n}\r\n\r\n.indx-c {\r\n    grid-column: 2;\r\n    grid-row: 2;\r\n}\r\n\r\n.indx-flex .flex-items {\r\n    display: flex;\r\n    flex-wrap: nowrap;\r\n}\r\n\r\n.flex-items > div {\r\n    width: 80px;\r\n    /*margin: 5px;\r\n    padding:2px;\r\n    text-align: center;\r\n    line-height: 75px;*/\r\n}\r\n\r\n.canvasjs-chart-credit {\r\n    display: none\r\n}\r\n\r\n.input-group-append .sepBorder {\r\n    height: 20px\r\n}\r\n\r\n.PanelArea {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.PanelContentArea {\r\n    height: 100%;\r\n    width: 100%;\r\n    background-color: var(--color-panel-background);\r\n    /* display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: center;*/\r\n    overflow: auto !important;\r\n    overflow-x: hidden !important;\r\n    border-radius: 0.5rem;\r\n    padding: 0.5em\r\n}\r\n\r\n.ResizeHandleOuter {\r\n    flex: 0 0 2em;\r\n    position: relative;\r\n    outline: none;\r\n    background-color: #363636 /* #7a7a7a4a*/ /*  --background-color: transparent; */\r\n}\r\n\r\n    .ResizeHandleOuter[data-resize-handle-active] {\r\n        --background-color: var(--color-solid-resize-bar-handle);\r\n    }\r\n\r\n.white-content .ResizeHandleOuter {\r\n    background-color: #d2d6dd !important\r\n}\r\n\r\n.ResizeHandleInner {\r\n    position: absolute;\r\n    top: 0.25em;\r\n    bottom: 0.25em;\r\n    left: 0.25em;\r\n    right: 0.25em;\r\n    border-radius: 0.25em;\r\n    background-color: #2e2e2e; /* #ffffff var(--background-color) */\r\n    transition: background-color 0.2s linear;\r\n}\r\n\r\n.white-content .ResizeHandleInner {\r\n    background-color: #636c83 !important\r\n}\r\n\r\n.Button {\r\n    color: var(--color-default);\r\n    background-color: var(--color-button-background);\r\n    border: 1px solid var(--color-button-border);\r\n    border-radius: 0.25rem;\r\n    padding: 0.25rem 0.5rem;\r\n    cursor: pointer;\r\n}\r\n\r\n    .Button:hover {\r\n        background-color: var(--color-button-background-hover);\r\n    }\r\n\r\n.Link {\r\n    display: block;\r\n    color: var(--color-link);\r\n    margin-bottom: 0.5rem;\r\n}\r\n\r\n.Icon {\r\n    width: 1em;\r\n    height: 1em;\r\n    position: absolute;\r\n    left: calc(50% - 0.5rem);\r\n    top: calc(50% - 0.35rem);\r\n    color: #fff;\r\n}\r\n\r\n.accTypeDd .dropdown-item.active {\r\n    color: #fff !important;\r\n    text-decoration: none !important;\r\n    background-color: #007bff !important;\r\n}\r\n\r\n.white-content .accTypeDd .dropdown-item.active {\r\n    color: #fff !important;\r\n    text-decoration: none !important;\r\n    background-color: #007bff !important;\r\n}\r\n\r\n.balance-area .rendered-text-span, .move-money-form .rendered-text-span {\r\n    font-weight: bold\r\n}\r\n\r\nhr {\r\n    margin-top: 0.5rem;\r\n    margin-bottom: 0.5rem;\r\n}\r\n\r\n.first-row {\r\n    background: #f1f1f1;\r\n    padding: 0.5rem 0;\r\n    margin: 0 0 1rem 0;\r\n}\r\n\r\n.position-panel .first-row > div > * {\r\n    margin-bottom: 0 !important;\r\n}\r\n\r\n#dropdownAccType {\r\n    width: 120px\r\n}\r\n\r\n.order-ticket .input-group, .order-ticket .form-group {\r\n    margin-bottom: 0 !important;\r\n}\r\n\r\n.order-ticket .form-check {\r\n    margin-top: 0 !important;\r\n}\r\n\r\n.order-ticket label {\r\n    font-size: 13px\r\n}\r\n\r\n.order-ticket .form-group .form-control, .order-ticket .input-group .form-control {\r\n    padding: inherit !important\r\n}\r\n\r\n.order-ticket .form-check .form-check-label, .order-ticket .custom-control-label {\r\n    width: 100%;\r\n}\r\n\r\n.form-control:focus {\r\n    border-color: #808080 !important;\r\n}\r\n\r\n.white-content .form-control:focus {\r\n    border-color: #424242 !important;\r\n}\r\n\r\n.order-ticket .custom-radio .custom-control-input:checked ~ .custom-control-label::before {\r\n    background-color: #007bff !important;\r\n    border-color: #007bff !important;\r\n}\r\n\r\n.order-ticket .custom-control-input:checked ~ .custom-control-label::before {\r\n    background-color: #007bff;\r\n}\r\n\r\n.white-content .order-ticket .quoteListOptionsContainer,\r\n.white-content .create-alert .quoteListOptionsContainer {\r\n    background: none;\r\n}\r\n\r\n.order-ticket .quoteListOptionsContainer,\r\n.create-alert .quoteListOptionsContainer {\r\n    padding: 0 !important;\r\n    background: none;\r\n}\r\n\r\n    .order-ticket .quoteListOptionsContainer .input-group,\r\n    .create-alert .quoteListOptionsContainer .input-group {\r\n        display: flex !important;\r\n        flex-wrap: nowrap;\r\n    }\r\n\r\n\r\n.white-content .order-ticket .react-tags__search input,\r\n.white-content .create-alert .react-tags__search input {\r\n    background: #fff !important;\r\n    color: #222a42 !important;\r\n    border: 1px solid #ced4da;\r\n}\r\n\r\n.white-content .order-ticket .react-tags,\r\n.white-content .create-alert .react-tags {\r\n    background: none !important;\r\n    border-color: #1d253b80\r\n}\r\n\r\n\r\n\r\n.order-ticket .react-tags input,\r\n.create-alert .react-tags input {\r\n    background: none !important;\r\n    border-top-left-radius: 0.4rem;\r\n    border-bottom-left-radius: 0.4rem;\r\n    background-color: transparent;\r\n    background-clip: padding-box;\r\n    /* border-top-right-radius: 0.5rem;\r\n    border-bottom-right-radius: 0.5rem;\r\n    */\r\n}\r\n\r\n\r\n\r\n\r\n.white-content .order-ticket .form-control {\r\n    background: #fff;\r\n    /* border: 1px solid #898e9b*/\r\n}\r\n\r\n.order-ticket .form-control {\r\n    /* border-color: #666666;*/\r\n    background: #000;\r\n}\r\n\r\n.order-quote-brief {\r\n    box-shadow: 0 1px 8px 0px rgb(123 123 123 / 60%) !important;\r\n    border-radius: 20px;\r\n    border: 1px solid #bcbdc2;\r\n}\r\n\r\n    .order-quote-brief .table-responsive-sm, .order-quote-brief .table-responsive {\r\n        padding-bottom: 0 !important\r\n    }\r\n\r\n    .order-quote-brief:nth-child(1) > .table-responsive-sm {\r\n        padding: 0.3rem\r\n    }\r\n\r\n    .order-quote-brief .wl-quote {\r\n        width: auto;\r\n        max-width: 100%;\r\n        margin: 0px;\r\n        padding: 0em;\r\n        background: none\r\n    }\r\n\r\n    .order-quote-brief .wl-item1 {\r\n        height: auto\r\n    }\r\n\r\n    .order-quote-brief .bottomPart td:nth-child(2) div {\r\n        border: none !important\r\n    }\r\n\r\n    .order-quote-brief tr:nth-child(1) td.first-td {\r\n        border: none;\r\n        padding: 0px !important\r\n    }\r\n\r\n    .order-quote-brief .bottomPart {\r\n        box-shadow: none;\r\n    }\r\n\r\n    .order-quote-brief .bidsCon th, .order-quote-brief .asksCon th {\r\n        text-align: center\r\n    }\r\n\r\n.white-content select.form-control option,\r\n.move-money-form select.form-control option {\r\n    padding: 0.3rem 0;\r\n    font-size: 13px;\r\n    color: #333\r\n}\r\n\r\nselect.form-control option {\r\n    padding: 0.3rem 0;\r\n    font-size: 13px;\r\n    color: #333\r\n}\r\n\r\n.btn-buy {\r\n    background: blue !important;\r\n    color: #fff !important;\r\n}\r\n\r\n.btn-sell {\r\n    background: #c51f1f !important;\r\n    color: #fff !important;\r\n}\r\n\r\n.order-ticket .btn-buy:hover, .order-ticket .btn-buy:focus, .order-ticket .btn-buy:active,\r\n.order-ticket .btn-buy.active, .order-ticket .btn-buy:active:focus, .order-ticket .btn-buy:active:hover,\r\n.order-ticket .btn-buy.active:focus, .order-ticket .btn-buy.active:hover {\r\n    background-color: blue !important;\r\n    background-image: none !important;\r\n}\r\n\r\n.order-ticket .btn-sell:hover, .order-ticket .btn-sell:focus, .order-ticket .btn-sell:active,\r\n.order-ticket .btn-sell.active, .order-ticket .btn-sell:active:focus, .order-ticket .btn-sell:active:hover,\r\n.order-ticket .btn-sell.active:focus, .order-ticket .btn-sell.active:hover {\r\n    background-color: #c51f1f !important;\r\n    background-image: none !important;\r\n}\r\n\r\n.was-validated .custom-control-input:valid ~ .custom-control-label::before {\r\n    background-color: inherit !important;\r\n    border-color: inherit !important;\r\n    /*border: inherit !important;*/\r\n}\r\n\r\n.was-validated .custom-control-input:valid ~ .custom-control-label,\r\n.custom-control-input.is-valid ~ .custom-control-label {\r\n    color: inherit !important\r\n}\r\n\r\n.was-validated .form-control:valid {\r\n    border-color: #28a745 !important;\r\n    background-image: none !important;\r\n}\r\n\r\n.was-validated .reuter-error {\r\n    display: block\r\n}\r\n\r\n.was-validated .reuter-col-error .quoteListOptionsContainer {\r\n    border-color: #ff8d72;\r\n    padding-right: calc(1.5em + 0.75rem);\r\n    background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e\");\r\n    background-repeat: no-repeat;\r\n    background-position: right calc(0.375em + 0.1875rem) center;\r\n    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\r\n}\r\n\r\n.was-validated .reuter-col-error .react-tags__search input {\r\n    border: 1px solid #ff8d72 !important\r\n}\r\n\r\n\r\n\r\n.trading-alert-con .h4 {\r\n    margin-bottom: 0;\r\n}\r\n\r\n.trading-alert-con p {\r\n    color: #1d253b;\r\n    font-weight: bold\r\n}\r\n\r\n.modal-content .modal-body {\r\n    /*line-height: 1.9 !important;*/\r\n    padding: 10px 24px 10px 24px;\r\n}\r\n\r\n.move-money-form {\r\n    /*margin-top:0.5rem*/\r\n}\r\n\r\n    .custome-card h5, .custome-card .h5, .move-money-form h5 {\r\n        margin-bottom: 0.5rem !important\r\n    }\r\n\r\n\r\n\r\n.display-flex {\r\n    display: flex\r\n}\r\n\r\n.btn-cancel {\r\n    opacity: 0.6;\r\n    background: #858585 !important;\r\n    background-image: none !important\r\n}\r\n\r\n    .btn-cancel:hover, .btn-cancel:focus, .btn-cancel:active, .btn-cancel.active, .btn-cancel:active:focus,\r\n    .btn-cancel:active:hover, .btn-cancel.active:focus, .btn-cancel.active:hover {\r\n        opacity: 1;\r\n        background-color: #5a5a5a !important;\r\n        background-image: none !important\r\n    }\r\n\r\n\r\n\r\n.sector-rank .badge {\r\n    font-size: 100%\r\n}\r\n\r\n.sector-rank .h5 {\r\n    margin-top: 0.5rem\r\n}\r\n\r\n.sector-rank .nav-tabs .nav-item.show .nav-link, .sector-rank .nav-tabs .nav-link.active {\r\n    color: #495057 !important;\r\n    background-color: #fff !important;\r\n    border-color: #dee2e6 #dee2e6 #fff !important;\r\n}\r\n\r\n.sector-rank .nav-link {\r\n    padding: 0.5rem 0.7rem\r\n}\r\n\r\n.user-profile .form-check {\r\n    margin-top: 0 !important\r\n}\r\n\r\n.formStyleError {\r\n    border-color: red,\r\n}\r\n\r\n.formErrorMsg {\r\n    color: red;\r\n    font-size: x-small;\r\n    align-self: flex-start;\r\n    /*padding-top: 2px*/\r\n}\r\n\r\n.user-profile input {\r\n    margin-bottom: 0.1rem\r\n}\r\n\r\n.user-profile .form-group {\r\n    margin-bottom: 0.1rem;\r\n}\r\n\r\n.fixed-plugin .appMenu .dropdown-menu {\r\n    width: auto;\r\n}\r\n\r\n.font-icon {\r\n    font-size: 0.9em !important\r\n}\r\n\r\n.column-gap-1 {\r\n    column-gap: 0.1rem\r\n}\r\n\r\n.column-gap-2 {\r\n    column-gap: 0.2rem\r\n}\r\n\r\n.column-gap-3 {\r\n    column-gap: 0.3rem\r\n}\r\n\r\n.column-gap-4 {\r\n    column-gap: 0.4rem\r\n}\r\n\r\n.column-gap-5 {\r\n    column-gap: 0.5rem\r\n}\r\n\r\n.translate-middle {\r\n    transform: translate(-50%,-10%) !important;\r\n    z-index: 10;\r\n}\r\n\r\n.start-100 {\r\n    left: 100% !important;\r\n}\r\n\r\n.start-75 {\r\n    left: 75% !important;\r\n}\r\n\r\n.top-0 {\r\n    top: 0 !important;\r\n}\r\n\r\n\r\n\r\n.dropdown-toggle::after {\r\n    display: none;\r\n}\r\n\r\n.ag-theme-balham .ag-root-wrapper {\r\n    border: 0px !important\r\n}\r\n\r\n@media (min-width: 576px) {\r\n    .small-modal .modal-dialog {\r\n        max-width: 30vw !important;\r\n    }\r\n\r\n    .medium-modal .modal-dialog {\r\n        max-width: 55vw !important;\r\n    }\r\n\r\n    .large-modal .modal-dialog {\r\n        max-width: 75vw !important;\r\n    }\r\n}\r\n\r\n.fixed-plugin .fa {\r\n    color: #ffffff;\r\n    padding: 10px;\r\n    border-radius: 0 0 6px 6px;\r\n    width: auto;\r\n}\r\n\r\n.user-alerts, .user-alerts .tab-content {\r\n    width: 100%\r\n}\r\n\r\n.fa-medium-font {\r\n    font-size: 1.5em\r\n}\r\n\r\n.alert-conf-row {\r\n    padding: 1rem;\r\n    justify-content: end;\r\n    gap: 2rem;\r\n    background: #f3f3f3;\r\n    margin-right: 1rem !important;\r\n    margin-left: 1rem !important;\r\n    border: 1px solid #ffffff;\r\n    border-bottom-left-radius: 0.5rem;\r\n    border-bottom-right-radius: 0.5rem;\r\n    border-top: 0;\r\n    box-shadow: 0px 1px 3px lightgrey inset\r\n}\r\n\r\n\r\n\r\n.detailed-quote .wl-quote {\r\n    width: 75%;\r\n    max-width: 90%\r\n}\r\n\r\n.sell-color-btn-outline {\r\n    border: 1px solid #d63d3d;\r\n    color: #d63d3d;\r\n}\r\n\r\n.buy-color-btn-outline {\r\n    border: 1px solid #0000ff;\r\n    color: #0000ff;\r\n}\r\n\r\n.sell-color-btn {\r\n    border: 1px solid #d63d3d !important;\r\n    background-color: #d63d3d !important;\r\n}\r\n\r\n.buy-color-btn {\r\n    border: 1px solid #0000ff !important;\r\n    background-color: #0000ff !important;\r\n}\r\n\r\n.opacity-contrast {\r\n    opacity: 0.8\r\n}\r\n\r\n.detailed-quote .btn {\r\n    padding: 3px 30px !important\r\n}\r\n\r\n.cursor-pointer {\r\n    cursor: pointer\r\n}\r\n\r\n.detailed-quote .table-responsive {\r\n    padding-bottom: 0\r\n}\r\n\r\n.detailed-quote hr {\r\n    margin-top: 0 !important\r\n}\r\n\r\n.detailed-quote .toast {\r\n    font-size: inherit\r\n}\r\n\r\n.modal-search-backdrop {\r\n    opacity: 0.2\r\n}\r\n\r\n.modal-search .quoteListOptionsContainer {\r\n    background: #fff;\r\n}\r\n\r\n.modal-search .react-tags__search input {\r\n    background: #fff;\r\n    width: 100% !important\r\n}\r\n\r\n.modal-search .react-tags {\r\n    background: #fff;\r\n    width: 100% !important\r\n}\r\n\r\n.modal-search .input-group-append {\r\n    display: none\r\n}\r\n\r\n.detailed-quote .list-group-horizontal > button {\r\n    min-width: 110px\r\n}\r\n\r\n/*.table td, .table th {\r\n    padding: 0.1em\r\n}*/\r\n\r\n.detailed-quote table .A td {\r\n    color: #21a521 !important;\r\n    /*  background-color: #c3e6cb !important;\r\n    border: 1px solid #15572406*/\r\n}\r\n\r\n.detailed-quote table .B td {\r\n    color: #de0000 !important;\r\n    /* background-color: #f5c6cb !important;\r\n    border: 1px solid #721c2406;*/\r\n}\r\n\r\n.fa-sm {\r\n    font-size: 0.5em !important\r\n}\r\n\r\n.max-scroll-clip {\r\n    height: 315px\r\n}\r\n\r\n\r\n/*@media (min-width: 1200px) {\r\n    .col-xl-3 {       \r\n        flex: 0 0 33.333333%;\r\n        max-width: 33.333333%;\r\n    }\r\n}*/\r\n@keyframes stretch {\r\n    0% {\r\n        transform: scale(0.3);\r\n        background-color: red;\r\n        border-radius: 100%;\r\n    }\r\n\r\n    50% {\r\n        opacity: 0.5\r\n    }\r\n\r\n    100% {\r\n        transform: scale(1.5);\r\n        background-color: red;\r\n        border-radius: 100%;\r\n        opacity: 0.1\r\n    }\r\n}\r\n/* all row drag */\r\n/*.ag-cell[col-id=\"reuters\"] {\r\n    overflow: inherit !important;\r\n}\r\n\r\n    .ag-cell[col-id=\"reuters\"] .ag-cell-value {\r\n        padding-left: 0px;\r\n    }\r\n\r\n    .ag-cell[col-id=\"reuters\"] .ag-icon {\r\n        visibility:hidden\r\n    }\r\n\r\n    .ag-cell[col-id=\"reuters\"] .ag-row-drag {\r\n        position: absolute;\r\n        width: 1200px;\r\n        z-index: 2;\r\n    }\r\n*/\r\n\r\n\r\n@media screen and (min-width: 30em) {\r\n    .react-tags__search {\r\n        /* this will become the offsetParent for suggestions */\r\n        position: relative;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 500px) {\r\n    .mrktDetails {\r\n        display: none\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 630px) {\r\n\r\n   \r\n\r\n    .egxStats .card:nth-child(1) {\r\n        display: none\r\n    }\r\n\r\n    #popover-contained {\r\n        width: 275px;\r\n    }\r\n\r\n        #popover-contained .col:last-child {\r\n            display: none\r\n        }\r\n\r\n    .pp-table table th {\r\n        font-size: 8px;\r\n    }\r\n\r\n    .pp-table table td {\r\n        font-size: 9px !important;\r\n    }\r\n        \r\n}\r\n\r\n#popover-alerts {\r\n}\r\n\r\n@media only screen and (max-width: 735px) {\r\n    .egxStats .card:nth-child(2) {\r\n        display: none\r\n    }\r\n\r\n    .navbar {\r\n        line-height: normal !important;\r\n        /*border-bottom: 1px solid;*/\r\n        background-color: #fff !important;\r\n        padding: .5rem 0rem !important;\r\n        height: auto !important;\r\n    }\r\n\r\n    .navbar-collapse {\r\n        border-bottom: 1px solid #ccc !important;\r\n        padding-bottom:1rem\r\n    }\r\n\r\n    .navbar-nav {\r\n        margin-left: 0 !important;\r\n        margin-top: 1rem !important;\r\n        margin-bottom: 1rem !important;\r\n    }\r\n\r\n    .mian-nav li.nav-item {\r\n        margin: 0 !important;        \r\n    }\r\n\r\n    .nav-pills .nav-link {\r\n        min-width: 100px !important;\r\n        font-size: 12px !important;\r\n        font-weight: 600 !important;\r\n        margin:0.4rem 0.2rem\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 810px) {\r\n    .egxStats .card:nth-child(3) {\r\n        display: none\r\n    }\r\n\r\n    .sysAlert-con {\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 770px) {\r\n\r\n    #left {\r\n        float: none !important;\r\n        width: 100% !important;\r\n    }\r\n\r\n    #right {\r\n        float: none !important;\r\n        width: 100% !important;\r\n    }\r\n}\r\n\r\n\r\n@media only screen and (max-width: 880px) {\r\n    .egxStats .card:nth-child(4) {\r\n        display: none\r\n    }\r\n\r\n    #right {\r\n        /*display: none*/\r\n        /* top: 140px;*/\r\n        position: inherit;\r\n        /*clear: both;*/\r\n    }\r\n\r\n    #left {\r\n        width: 100% !important;   \r\n    }\r\n\r\n    .welcome-div {\r\n        display: none\r\n    }\r\n\r\n    /*.navbar {\r\n        line-height: normal !important;\r\n        border-bottom: none;\r\n        background-color: #fff !important;\r\n        padding: .5rem 0rem;\r\n        height: 80px;\r\n    }*/\r\n\r\n    .pp-table table th {\r\n        font-size: 10px;\r\n    }\r\n\r\n    .pp-table table td {\r\n        font-size: 11px;\r\n    }\r\n}\r\n\r\n\r\n@media only screen and (min-width: 820px) {\r\n    .egxStats .card:nth-child(4) {\r\n        display: none\r\n    }\r\n\r\n    .navbar {\r\n        line-height: normal !important;\r\n        border-bottom: none;\r\n        background-color: #fff !important;\r\n        padding: .5rem 0rem;\r\n        height: 80px;\r\n    }\r\n\r\n    .navbar-collapse {\r\n        border-bottom: none !important;\r\n    }\r\n\r\n    #right {\r\n        width: 38%\r\n    }\r\n\r\n    #left {\r\n        width: 60% !important;\r\n        /*float: none*/\r\n    }\r\n\r\n    .welcome-div {\r\n        display: none\r\n    }\r\n\r\n    .pp-table table th {\r\n        font-size: 11px;\r\n    }\r\n\r\n    .pp-table table td {\r\n        font-size: 12px;\r\n    }\r\n}\r\n\r\n@media only screen and (min-width: 990px) {\r\n    .egxStats .card:nth-child(4) {\r\n        display: none\r\n    }\r\n  \r\n    .navbar {\r\n        line-height: normal !important;\r\n        border-bottom: none;\r\n        background-color: #fff !important;\r\n        padding: .5rem 0rem;\r\n        height: 80px;\r\n    }\r\n\r\n    .navbar-collapse {\r\n        border-bottom: none !important;\r\n    }   \r\n\r\n    #right {       \r\n        width: 28%\r\n    }    \r\n\r\n    #left {\r\n        width: 70% !important;\r\n        /*float: none*/\r\n    }\r\n\r\n    .welcome-div {\r\n        display:none\r\n    }\r\n\r\n    .pp-table table th {\r\n        font-size: 11px;\r\n    }\r\n\r\n    .pp-table table td {\r\n        font-size: 12px;\r\n    }\r\n}\r\n\r\n@media (min-width: 1200px) {\r\n    #right {\r\n        top: 144px;\r\n        width: 350px;\r\n        position: absolute; /*fixed*/\r\n        min-height: 83.5vh;\r\n        transition: top 0.1s ease-out; /* This creates the smooth movement effect */\r\n    }\r\n\r\n    #left {\r\n        width: 840px !important;\r\n        /*padding-right: 10px;*/\r\n        /*border: 1px solid #de0000*/\r\n    }\r\n   \r\n\r\n    #portfolio-card button {\r\n        font-size: 12px !important;\r\n        font-weight: 600 !important;\r\n    }\r\n    .welcome-div {\r\n        display: block\r\n    }\r\n\r\n    .col-xl-8 {\r\n        width: 60.5% !important;\r\n    }\r\n\r\n    .pp-table table th {\r\n        font-size: 12px;\r\n    }\r\n\r\n    .pp-table table td {\r\n        font-size: 13px;\r\n    }\r\n}\r\n\r\n@media only screen and (max-width: 1240px) {\r\n    .statsCon {\r\n        display: none\r\n    }\r\n\r\n    \r\n    \r\n}\r\n\r\n@media only screen and (min-width: 1280px) {    \r\n\r\n    #root .container-fluid {\r\n        max-width: 1280px;\r\n        width: 1280px;\r\n        padding: 0 40px;\r\n        /*border: 1px solid #000;*/\r\n    }\r\n\r\n    #left {\r\n        width: 810px !important;\r\n        /*padding-right: 10px;*/\r\n        /*border: 1px solid #de0000*/\r\n    }\r\n\r\n    #right {\r\n        width: 350px;\r\n        max-width: 350px;\r\n        padding: 10px;\r\n        font-size: 12px\r\n        /*border: 1px solid #21a521*/\r\n    }\r\n\r\n    .col-xl-8 {\r\n        width: 60.5% !important;\r\n    }\r\n    \r\n}\r\n\r\n@media only screen and (min-width: 1366px) {    \r\n\r\n    #root .container-fluid {\r\n        max-width: 1360px;\r\n        width: 1360px;\r\n        padding: 0 20px;\r\n        /*border: 1px solid #000;*/\r\n    }\r\n\r\n    #left {\r\n        width: 955px !important;\r\n        /*padding-right: 10px;*/\r\n        /*border: 1px solid #de0000*/\r\n    }\r\n\r\n    #right {\r\n        width: 350px;\r\n        max-width: 350px;\r\n        padding: 10px;\r\n        font-size: 12px\r\n        /*border: 1px solid #21a521*/\r\n    }  \r\n\r\n    #portfolio-card button {\r\n        font-size: 13px !important;\r\n        font-weight: inherit !important;\r\n    }\r\n\r\n    .pp-table table td {\r\n        font-size: 14px;\r\n    }\r\n}\r\n\r\n\r\n@media only screen and (min-width: 1440px) {\r\n    #root .container-fluid {\r\n        width: 1512px;\r\n        max-width: 1512px;\r\n        padding: 0 45px;\r\n        /*border: 1px solid #000;*/\r\n    }\r\n\r\n    #left {\r\n        /*width: 1027px !important;*/\r\n        width: 1010px !important;\r\n        /*padding-right: 20px;*/\r\n        /*border: 1px solid #de0000*/\r\n    }\r\n\r\n    #right {\r\n        /*width: calc(1440px - 960px) !important;*/\r\n        width: 373px;\r\n        max-width: 413px;\r\n        padding: 20px;\r\n        font-size: inherit !important;\r\n        /*border: 1px solid #21a521*/\r\n    }\r\n\r\n    .col-xl-8 {\r\n        width: 67.666667% !important;\r\n    }\r\n\r\n    .pp-table table td {\r\n        font-size: 15px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
